import { Injectable } from '@angular/core';
import { CONFIG } from './config';
import { StringHelper } from '../../core/helpers/strings.helper';

@Injectable()
export class AppConfig {
    USE_UNIFIED_PROVISIONAL_OFFER_FLOW: boolean;
    static config = null;
    static env = null;
    static CLIENT_VERSION: string;
    static SHOW_BRM_APPROVE_TAB: boolean;
    static SHOW_BRM_ONBOARDING_FOR_CM: boolean;
    static SHOW_DOCUMENT_APPROVE_TAB: boolean;
    static SHOW_LIMIT_APPROVE_TAB: boolean;
    static SHOW_BRM_BUSINESS_ACCOUNT: boolean;
    static SHOW_BUSINESS_EARNINGS: boolean;
    static SHOW_BRM_ONBOARDING: boolean;
    static SHOW_ALL_COMMISSIONS: boolean;
    static SHOW_BUSINESS_ACCOUNT_CASHOUT_BUTTON: boolean;
    static TRACK_EVENT: boolean;
    static CAN_SHOW_PARTNERS_DEPOSIT_COMMISSIONS_BALANCE: boolean;
    static USE_NEW_WITHDRAWAL: boolean;
    static USE_NEW_PURCHASE: boolean;
    static USE_NEW_AIRTIME: boolean;
    static SHOW_REFERRALS: boolean;
    static SHOULD_SHOW_REWARDS_V2: boolean;
    static SHOULD_USE_UNIFIED_BANNER: boolean;
    static SHOW_NEW_TERMINAL_ASSIGNMENT_REQUESTS: boolean;
    static SHOW_SC_PERFORMANCE_REPORTS: boolean;
    static SHOW_LOAN_PREQUALIFICATION_AGGREGATORS: boolean;
    static SHOW_LOAN_PREQUALIFICATION_RC: boolean;
    static SHOW_LOAN_AGGREGATORS_PREQUALIFICATION_LOOKUP: boolean;
    static SHOW_LOAN_AGGREGATORS_PREQUALIFICATION_LOOKUP_V2: boolean;
    USE_PREQUALIFIED_BOS_V2: boolean;
    USE_PREQUALIFICATION_LOOKUP_V2: boolean;
    static SHOW_LOAN_AGGREGATORS_SCHEDULE_SIMULATION: boolean;
    static SHOW_WCL_IN_BUSINESS_USER_DASHBOARD: boolean;
    static SHOW_WCL_BUSINESS_USER_DASHBOARD_NEW_BADGE: boolean;
    static SHOW_OVERDRAFT_RUNNING_LOANS_V2: boolean;
    SHOW_OVERDRAFT_RUNNING_LOANS_V2_SALES_VALUE: boolean;
    SHOW_LOAN_PRODUCT_SELECTION_FLOW: boolean;
    USE_OVD_NEW_AGREEMENT_FLOW: boolean;
    SHOW_OVERDRAFT_RUNNING_LOANS_V2_LEARN_ABOUT_OVERDRAFT: boolean;
    SHOW_OVERDRAFT_RUNNING_LOANS_V2_DEACTIVATE_OVERDRAFT: boolean;
    static SHOW_PERFORMANCE_TRACKER_FOR_RM_SC: boolean;
    static SHOW_MONIECRM: boolean;
    static SHOW_TICKET_MANAGER: boolean;
    static SHOW_PRM_PERFORMANCE_TRACKER: boolean;
    static ENABLE_SUB_BRM: boolean;
    static SHOW_SPO_PERFORMANCE_TRACKER: boolean;
    static SHOW_KIOSK_MARKETERS: boolean;
    static SHOW_REMOTE_GROWTH_MODULE: boolean;
    static SHOW_REMOTE_ADDRESS_VERIFICATION_MODULE: boolean;
    static SHOW_BUSINESS_REMAPPING: boolean;
    static SHOW_ACCOUNTS_MENU_FOR_CM: boolean;
    static SHOW_WELFARE_ACCOUNT_FOR_BRM: boolean;
    static SHOW_WELFARE_ACCOUNT_FOR_SC: boolean;
    static SHOW_WELFARE_ACCOUNT_FOR_RM: boolean;
    SHOW_BRM_ONBOARDING_NEXT_OF_KIN: boolean;
    SHOW_BRM_ONBOARDING_CLUSTER_NAME: boolean;
    VALIDATE_BO_WCL_KYC: boolean;
    USE_LOAN_EXPIRED_V2: boolean;
    USE_PENDING_LOAN_TIMELINE_V2: boolean;
    SHOW_NEW_SETTING_VIEW: boolean;
    MONIEPOINT_TERMINAL;
    MONIEPOINT_HOST;
    MONIEPOINT_POS_ERP_INTEGRATION;
    MONIEBOOK_ENV_URL;
    static MONIEBOOK_FEATURE_SHOW_REFERRALS: boolean;
    MONIEPOINT_USER_URL;
    MONIEPOINT_WORKFLOW_URL;
    MONIEPOINT_SAVINGS;
    MONIEPOINT_LOANS;
    WLC_MANAGEMENT;
    LOAN_GATEWAY_SERVICE_URL;
    LMS_SERVICE_URL: string;
    MARKUP_SERVICE_URL: string;
    WCL_SERVICE_URL_V2: string;
    OVD_SERVICE_URL_V2: string;
    ENABLE_WCL_COMBINED_GUARANTOR_SUBMISSION: boolean;
    ENABLE_WCL_PLATFORM_HTTP_HEADER: boolean;
    USE_WCL_BUSINESS_OWNER_REPAYMENT_ACCOUNTS: boolean;
    USE_WCL_BUSINESS_OWNER_DISBURSEMENT_ACCOUNTS: boolean;
    USE_WCL_BUSINESS_ADDRESS_VERIFICATION_V2: boolean;
    ENABLE_WCL_GEOLOCATION_HIGH_ACCURACY: boolean;
    WCL_PORTFOLIO_MANAGEMENT;
    MONIEPOINT_CARDS;
    MONIEPOINT_INSURANCE;
    MONIEPOINT_ACCOUNTING;
    MONIEPOINT_ACCOUNTING_STAGING;
    MONIEPOINT_ACCOUNTS;
    MONIEPOINT_FV_CORE;
    MONIEPOINT_WITHDRAWAL;
    MONIEPOINT_DEPOSIT;
    MONIEPOINT_OFFLINE_PAYMENT;
    MONIEPOINT_OFFLINE_SALES_URL;
    MONIEPOINT_TERMINAL_INVENTORY;
    MONIEPOINT_AREA;
    SHOW_MOBILE_WEB_VIEW;
    DEFAULT_OTP_COUNT_DOWN;
    MONIEPOINT_LOGISTICS;
    MONIEPOINT_REPORT;
    MONIEPOINT_NOTIFICATION;
    MONIEPOINT_BILL_PAYMENT;
    MONIEPOINT_GAMIFICATION;
    MONIEPOINT_REFERRALS_CASHOUT_SERVICE;
    MONIEPOINT_MFA_LOOM;
    MONIEPOINT_DASHBOARD;
    BASE_URL = '';
    REDIRECT_URL = '/login';
    ASSETS_HOST = '';
    DOMAIN_ID;
    REDIRECT_ACCESS_TOKEN;
    REDIRECT_LOGIN_USER_TYPE;
    KUWEGO_URL;
    KUWEGO_IMAGE_URL;
    KUWEGO_LOANS;
    FILE_SERVICE;
    FVS_FILE_SERVICE: string;
    MONIEPOINT_ONBOARDING;
    MONIEPOINT_AVS;
    mock: boolean;
    allowAgentLogin: boolean;
    appTimeout;
    clientId;
    SHOW_COMPLIANCE_VIEW: boolean;
    SHOW_CONSOLIDATION_VIEW: boolean;
    SHOW_FEE_WAIVER: boolean;
    SHOW_CAPITAL_LOANS_MENU: boolean;
    SHOW_CAPITAL_LOANS_WEB: boolean;
    SHOW_DOWNLOAD_POS_ACCOUNT_DETAILS: boolean;
    ALLOW_POS_REQUEST: boolean;
    SHOW_KYC_REGISTERED_BUSINESS: boolean;
    GRAFANA_URL: any;
    TIMEOUT: any;
    ALLOW_SIGN_UP: boolean;
    ALLOW_KYC: boolean;
    SHOW_TRAINING_VIEW: boolean;
    SHOW_RE_ACT_LINK_ONBOARDING_BO: boolean;
    META_MAP_FLOW_ID;
    META_MAP_LOW_LEVEL_ACCOUNT_FLOW_ID;
    META_MAP_PERSONAL_INFO_FLOW_ID;
    SHOW_POS_REQUEST_MENU: boolean;
    SHOW_CARDS_MENU: boolean;
    SHOW_SUPPORT: boolean;
    SHOW_CASHOUT_BUTTON: boolean;
    SHOW_BRM_DASHBOARD_V2: boolean;
    SHOW_TRANSACTION_SHARE_BUTTON: boolean;
    BUFFER_SIZE: number;
    LOG_TIMEOUT: number;
    MONIEPOINT_URL: string;
    SHOW_YEARLY_SUMMARY_REPORT: boolean;
    SHOW_WRITEOFF_PROMOTION: boolean;
    SHOW_TERMS_AND_CONDITIONS_MODAL_BO: boolean;
    SHOW_TERMS_AND_CONDITIONS_MODAL_BRM: boolean;
    SHOW_TERMS_AND_CONDITIONS_MODAL_RM: boolean;
    SHOW_TERMS_AND_CONDITIONS_MODAL_SC: boolean;
    SHOW_BRM_CASHOUT_PIN_FLOW: boolean;
    JWT_EXPIRY_CHECK: number;
    SHOW_SWITCH_TO_REG_BUSINESS: boolean;
    SHOW_DASHBOARD_ALERT_WIDGET: boolean;
    SHOW_BRM_WRITEOFF_ACTION: boolean;
    SHOW_BRM_RESET_PIN_FLOW: boolean;
    SHOW_BUSINESS_EFFICIENCY_UPDATE: boolean;
    SHOW_EOD_PRINTING: boolean;
    SHOW_SELF_TEST: boolean;
    RM_ONBOARDING_URL: string;
    SHOW_STAFF_USERS_MENU: boolean;
    SHOW_STAFF_DESIGNATION_MENU: boolean;
    SHOW_TERMINAL_ASSIGNMENT_UPDATE: boolean;
    USE_V2_SELECTION_PAGE: boolean;
    META_MAP_BRM_PROFLIE_VERIFICATION_LIVELINESS_FLOW_ID: any;
    SHOW_BRM_VERIFICATION_METAMAP_LIVELINESS_FLOW: any;
    SHOW_ONBOARDING_SUPPORT: any;
    SHOW_COURSES_WARNING_ON_CASHOUT: boolean;
    STAFF_USER_DEPOSIT_REQUEST: boolean;
    STAFF_USER_AIRTIME_REQUEST: boolean;
    STAFF_USER_BILL_PAYMENT_REQUEST: boolean;
    SHOW_RECURRING_TRANSFER_LIMIT: boolean;
    SHOW_INFINITE_RECURRING_TRANSFER: boolean;
    SHOW_BO_NEW_APPROVALS_UI: boolean;
    SHOW_BO_DEFAULT_APPROVAL_UI_NEW: boolean;
    SHOW_APP_DOWNLOAD_BANNER: boolean;
    USE_NEW_ONBOARDING_FLOW: boolean;
    USE_NEW_SIGN_UP_FLOW: boolean;
    USE_NEW_KYC_FLOW: boolean;
    USE_NEW_TRANSACTION_PIN: boolean;
    public MONIEPOINT_ORCHESTRATOR_SERVICE;
    SHOW_NOTIFICATION_PREFERENCE: any;
    SHOW_DOWNLOADABLE_MATERIAL: boolean;
    SHOW_NEW_ACCOUNT_VIEW: boolean;
    REMOVE_TRANSFER_ALL_TRANSACTIONS: boolean;
    SHOW_NEW_TRANSFER_EXPORT_URL: boolean;
    ROUTE_TO_DASHBOARD_AFTER_ONBOARDING: boolean;
    USE_MOBILE_MAX_FILE_SIZE: boolean;
    SHOW_NEW_TRANSFER: boolean;
    USE_NEW_META_MAP_BUTTON: boolean;
    SHOW_TRANSFER_LIMIT_MODAL: boolean;
    DEFAULT_TIME_FOR_METAMAP_STATUS_CALL: number;
    SET_DEFAULT_NOTIFICATION_PREFERENCE: boolean;
    SHOW_LOGIN_USSD: boolean;
    SHOW_TERMINAL_ASSIGNMENT_BUSINESS_UPDATE: boolean;
    HIDE_BUSINESSES_FOR_INVITE_ADMIN: boolean;
    SHOW_NEW_FLOW_INVITE_STAFF: boolean;
    SHOW_KYC_LEVEL_BANNER: boolean;
    EXTENDED_STATEMENT_DOWNLOAD: any;
    BUSINESS_OWNER_EXTENDED_STATEMENT_DOWNLOAD: boolean;
    SHOW_BUSINESS_OWNER_STATEMENT_EXPORT: boolean;
    DAILY_BUSINESS_STATEMENT_DOWNLOAD: boolean;
    DAILY_TERMINAL_STATEMENT_DOWNLOAD: boolean;
    SHOW_USER_PIN_MENU: any;
    MONIEPOINT_CRM_SERVICE: any;
    ENABLE_STAFF_USER_INVITE: boolean;
    SHOW_CARD_PENETRATION_WIDGET: boolean;
    SHOW_OLD_TRANSACTION_PIN_MENU: boolean;
    SHOW_KYC_TRANSACTION_LIMITS: boolean;
    SHOW_USER_PIN_MODAL_ON_BO_LOGIN: boolean;
    SHOW_SC_TERMINAL_ASSIGNMENT: boolean;
    USE_CONSOLIDATED_ALL_FOR_ALL_TRANSACTIONS: boolean;
    SHOW_BO_DASHBOARD_FOR_DIGITAL_BO: boolean;
    CAN_OPEN_BO_DIGITAL_ACCOUNT: boolean;
    CARDS_CAN_USE_USER_PIN: boolean;
    MONIEPOINT_DELIVERY_SERVICE: string;
    CAN_USE_DELIVERY_SERVICE: boolean;
    SHOW_BO_TABLE_V2: boolean;
    SHOW_POS_UPDATE: boolean;
    SHOW_SWAP_TERMINAL_UPDATE: boolean;
    CAN_USE_SUBLGA: boolean;
    CAN_BRM_EXTEND_GRACE_PERIOD_AFTER_EXPIRATION: boolean;
    TIME_ZONE: string;
    WEB_BICON: boolean;
    USE_KYC_API_ON_DASHBOARD: boolean;
    SHOW_TERMINAL_COMMISSION_FEE_SPLIT: boolean;
    USE_NEW_LOGIN_API: boolean;
    CAN_ADD_BUSINESSES_FOR_PENDING_BO: boolean;
    CAN_USE_SOFT_ONBOARDING: boolean;
    CARDS_CAN_COLLECT_CARDS: boolean;
    SHOW_PROFILE_BUTTON_ON_BO_PROFILE: boolean;
    USE_UUID_FOR_DEVICE_ID: boolean;
    USE_NIBSS_BVN_VERIFICATION: boolean;
    USE_NEW_STATEMENT_FLOW: boolean;
    USE_OTP_CHANGE_PASSWORD_AND_PIN: boolean; // deprecated
    USE_NEW_CHANGE_PASSWORD: boolean; // TODO: remove later
    USE_NEW_RESET_USER_PIN: boolean; // TODO: remove later
    SHOULD_USE_NEW_BVN_FLOW: boolean;
    SHOW_BRM_CARD_SALES_AGENT: boolean;
    SHOW_BRM_CARD_NEW_UI: boolean;
    SHOW_SC_TERMINAL_SWAP: boolean;
    USE_OLD_BUSINESS_OWNER_KYC: boolean;
    HIDE_PDF_STATEMENT_DOWNLOAD: boolean;
    USE_NEW_BO_STATEMENT_DOWNLOAD: boolean;
    CAN_USE_BUSINESS_NAME_CHANGE: boolean;
    SHOW_REFERRALS_CASHOUT: boolean;
    SHOW_BULK_TRANSFER: boolean;
    SHOW_CARD_REQUESTS: boolean;
    ADD_BUSINESS_DETAILS_MENU: boolean;
    CAN_USE_SMILE_ID: boolean;
    SHOW_ACCOUNT_CLOSURE: boolean;
    USE_OVERDRAFT_PAYMENT: boolean;
    SHOW_POS_ERP_INTEGRATION: boolean;
    SHOW_BRM_PUSH_CARDS_TO_SALES_AGENT: boolean;
    SHOW_COLLECT_CARD_MENU: boolean;
    MONIEPOINT_APPLICATION_STORE_URL: string;
    BRM_PUSH_TO_SALES_AGENT_CARD_COUNT: number;
    REFERRAL_PRE_REGISTRATION_API_RETRY_COUNT: number;
    REFERRAL_PRE_REGISTRATION_API_RETRY_INTERVAL: number;
    BRM_CAN_RETRIEVE_CARDS: boolean;
    SHOW_NEW_PROFILE_UPDATE_VIEW: boolean;
    USE_KYC_NIN_FLOW: boolean;
    BRM_CAN_USE_FLEXIBLE_CARD_COST: boolean;
    USE_BRM_KYC_NIN_FLOW: boolean;
    CAN_USE_IDENTITY_TOKEN: boolean;
    USE_LOGIN_OPTION: boolean;
    CAN_CHANGE_PASSCODE: boolean;
    SHOW_SIGN_UP_PASSCODE_FLOW: boolean;
    USE_CARD_PUSH_BATCH_SETTINGS: boolean;
    SHOW_USSD_BANKING_CHANNEL_SETTINGS: boolean;
    USSD_BANKING_CHANNEL_MODAL_MAXIMUM_USERS: number;
    USE_NEW_FORGET_PASSCODE_FLOW: boolean;
    USE_ACCOUNT_NUMBER_ALIAS: boolean;
    VALIDATE_DUPLICATE_TRANSFERS: boolean;
    SHOW_TERMINAL_TRANSACTION_WIDGET: boolean;
    SHOW_CARD_SALES_SUMMARY: boolean;
    USE_NEW_KYC_LEVEL2_FLOW: boolean;
    USE_NEW_KYC_LEVEL3_FLOW: boolean;
    CAN_HIDE_KYC_LEVEL1_PRIMER: boolean;
    USE_NEW_BRM_KYC_LEVEL2_FLOW: boolean;
    USE_NEW_BRM_KYC_LEVEL3_FLOW: boolean;
    REWARD_SERVICE_URL: string;
    SHOULD_SHOW_REWARDS: boolean;
    BRM_CAN_USE_CONFIG_FLEXIBLE_CARD_COST: boolean;
    SHOW_TERMINAL_ACTIVITY_SCORE: boolean;
    USE_PROFILE_SETUP: boolean;
    USE_CARD_DEVICE_ID: boolean;
    USSD_BANKING_CODE: string;
    USE_STAFF_USER_REFRESH_TOKEN: boolean;
    CAN_RESEND_OTP_VIA_WHATSAPP: boolean;
    CAN_USE_NEW_USSD: boolean;
    SHOW_BO_PERFORMANCE: boolean;
    USE_KAMONA_SIGN_IN: boolean;
    SHOW_CAC_BANNER: boolean;
    SHOW_BRM_CAC_INCOMPLIANT_BO: boolean;
    USE_DEVICE_ID_DECRYPTION: boolean;
    USE_ASYNC_LIVELINESS_CHECK: boolean;
    SHOW_UPDATE_DATE_OF_BIRTH: boolean;
    FO_ENVIRONMENT: string;
    TELEMETRY_ENABLE: boolean;
    TELEMETRY_BASE_URL: string;
    TELEMETRY_SERVICE_NAME: string;
    TELEMETRY_DEBUG_MODE: boolean;
    TELEMETRY_DEV_MODE: boolean;
    TELEMETRY_INTERVAL_MILLIS: number;
    SHOW_INCOMPLIANT_KYC_BANNER: boolean;
    SHOW_BRM_INCOMPLIANT_KYC_BANNER: boolean;
    USE_AUTO_ADDRESS_APPROVAL: boolean;
    CARDS_REQUIRE_TERMS_AND_CONDITIONS: boolean;
    static SHOW_INVENTORY: boolean;
    ENABLE_LIVENESS_FOR_CARD_ACTIVATION: boolean;
    CARD_TOOLS_UI_UPDATE_V1: boolean;
    USE_MERGE_DUPLICATE_PROFILE_FLOW: boolean;
    ALLOW_SIGN_UP_FOR_BRM: boolean;
    ALLOW_BRM_ADD_BUSINESS: boolean;
    ALLOW_BRM_USE_PASSPORT_PHOTOGRAPH_FOR_BO_ONBOARDING: boolean;
    ALLOW_BVN_FOR_KYC_LEVEL_1_BUSINESS_ONBOARDING: boolean;
    USE_GOOGLE_MAP_JAVASCRIPT_API: boolean;
    GEOLOCATION_THRESHOLD_IN_METER: number;
    USE_ADDRESS_REVALIDATION: boolean;
    SHOW_TERMINAL_QUOTA_UPDATE: boolean;
    SHOW_BRM_LGA_UPDATE_ON_FVS_VIEW: boolean;
    SHOW_FVS_ADDRESS_VERIFICATION_ROUTES: boolean;
    static SHOW_FVS_ADDRESS_VERIFICATION_MENU: boolean;
    static FVS_ADDRESS_VERIFICATION_TABS_TO_HIDE: string;
    SHOW_FVS_PENDING_COUNT_BANNER_ON_BRM_DASHBOARD: boolean;
    FVS_SHOW_ADDRESS_VERIFICATION_WIDGET: boolean;
    FVS_LOGIN_ROUTE_WITH_QUERY_PARAM: string;
    ALLOW_BRM_RE_UPDATE_LGA_ON_FVS: boolean;
    MINIMUM_ADDRESS_VERIFICATION_TIME_IN_DAYS: number;
    COUNTRY_FLAGS_URL: string;
    USE_NEW_COMPLIANCE_URLS: boolean;
    MAXIMUM_ADDRESS_VERIFICATION_TIME_IN_DAYS: number;
    SHOW_ADDRESS_VERIFICATION_POP_UP_EVERY_LOGIN: boolean;
    USE_CAC_BUSINESS_AFFILIATE_FLOW: boolean;
    USE_PEP_NATIONALITY_INCOME_LEVEL_1_FLOW: boolean;
    USE_BRM_PEP_NATIONALITY_INCOME_LEVEL_1_FLOW: boolean;
    SHOW_SWAP_UPDATE_FOR_SC_AND_BRM: boolean;
    METAMAP_SCRIPT_URL: string;
    FVS_SHOW_BRM_CAN_UPDATE_BO_ADDRESS: boolean;
    USE_MOCK_PEP_ISSUES_DATA: boolean;
    USE_KYC_CORRECTIONS_V2: boolean;
    USE_PHYSICAL_ADDRESS_VERIFICATION_FOR_KYC: boolean;
    USE_PHYSICAL_ADDRESS_VERIFICATION_FOR_BRM_KYC: boolean;
    USE_REGISTERED_BUSINESS_PRIMER_LABEL: boolean;
    USE_REGISTERED_BUSINESS_ROUTE: boolean;
    SHOW_NEW_FAULTY_FLOW: boolean;
    SC_PERFORMANCE_START_PERIOD: string;
    USE_LOOM_MFA_SDK: boolean;
    SHOW_TERMINAL_RETRIEVAL_UPDATE: boolean;
    static SHOW_MY_APPROVAL_REQUESTS: boolean;
    CAN_MAKE_STATE_LGA_OPTIONAL: boolean;
    USE_DAILY_STATEMENT_DATE_RANGE: boolean;
    SHOW_GLOBAL_SWAP_UPDATE: boolean;
    USE_STATEMENT_REPORT_URL: boolean;
    MONIEPOINT_STATEMENT: string;
    MONIEDESK_API_BASE_URL: string;
    MONIEDESK_CRM_SERVICE: string;
    MONIEDESK_ENTITY: string;
    MINIMUM_MFA_SIGN_UP_ALERT_KYC_LEVEL: number;
    MINIMUM_MFA_SIGN_UP_ALERT_TEXT: string;
    USE_NEW_DAILY_LIMIT_FLOW: boolean;
    ENFORCE_ADDRESS_VERIFICATION_NEW_DAILY_LIMIT_FLOW: boolean;
    ENFORCE_OPTION_ADDRESS_VERIFICATION_NEW_DAILY_LIMIT_FLOW: boolean;
    OTP_RESEND_V2: boolean;
    USE_2FA_FLOW_USER_PIN_RESET: boolean;
    USE_2FA_FLOW_FORGOT_PASSCODE: boolean;
    USE_2FA_FLOW_FORGOT_PASSWORD: boolean;
    USE_2FA_FLOW_PASSCODE_CHANGE: boolean;
    USE_2FA_FLOW_PASSWORD_CHANGE: boolean;
    SHOW_KYC_LVL1_BUSINESS_NAME_DESCRIPTION_SIZE: boolean;
    USE_ONBOARDING_MODULE_LAZY_LOADER: boolean;
    USE_NEW_LOAN_FACILITATOR_INPUT: boolean;
    USE_ANALYTICS_TRACKING_SERVICE_IN_LOANS: boolean;
    CUSTOMER_IO_WRITE_KEY: string;
    SHOW_PND_AND_LIENS_BANNER: boolean;
    SHOW_SC_RM_CASHOUT: boolean;
    SHOW_BRM_PRM_CASHOUT: boolean;
    PARTNER_ONBOARDING_MIGRATION: boolean;
    SHOW_REPAIR_CODE_UPDATE: boolean;
    SHOW_CUSTOM_TRANSACTION_FIELD_CONFIG: boolean;
    MONIEPOINT_POS;
    SHOW_PROFILE_EMAIL_UPDATE_BUTTON: boolean;
    SHOW_PROFILE_PHONE_NUMBER_UPDATE_BUTTON: boolean;
    SHOW_PROFILE_DOB_UPDATE_BUTTON: boolean;
    SHOW_PROFILE_IMAGE_UPDATE_BUTTON: boolean;
    CUSTOMER_IO_CDN_URL: string;
    SHOW_MONIEBOOK_ONBOARDING_ON_BO_DETAILS: boolean;
    MONIEBOOK_SERVICE_URL: string;
    MONIEBOOK_DASHBOARD_URL: string;
    SHOW_MONIEBOOK_AUTO_ONBOARD_BANNER: boolean;
    REMOVE_TC_DOCUMENT_FOR_BRM: boolean;
    SHOW_PERFORMANCE_TRACKER_COMMISSION_HISTORY: boolean;
    USE_OTP_WHATSAPP_DEVICE_REGISTRATION: boolean;
    USE_OTP_WHATSAPP_FORGOT_PASSCODE: boolean;
    USE_OTP_WHATSAPP_FORGOT_PASSWORD: boolean;
    USE_OTP_WHATSAPP_PASSCODE_CHANGE: boolean;
    USE_OTP_WHATSAPP_PASSWORD_CHANGE: boolean;
    USE_OTP_WHATSAPP_RESET_USER_PIN: boolean;
    SEND_SMS_OTP_2FA: boolean;
    SHOULD_USE_KYC_LVL2_UPGRADE_FLOW: boolean;
    SHOW_TERMINAL_ASSIGNMENT_TO_BACKOFFICE_UPDATE: boolean;
    WHATSPP_OTP_COUNTDOWN_IN_SECONDS: number;
    USE_NEW_OTP_DESIGN_DEVICE_REGISTRATION: boolean;
    SHOW_UPDATE_TERMINAL_STATUS_ACTION: boolean;
    static CARDS_USE_BRM_AUTHORITIES: boolean;
    SHOW_PROFILE_ADDRESS_UPDATE_BUTTON_KYC_LEVEL: number;
    SHOW_LIENS_ON_ACCOUNTS_PAGE: boolean;
    CARDS_USE_NEW_ASSIGNMENT_API: boolean;
    USE_NEW_TRANSFER_SUMMARY: boolean;
    MONIECRM_URL: string;
    ADDRESS_VERIFICATION_MFE_URL: string;
    TICKET_MANAGER_URL: string;
    MONIEPOINT_PAYMENT_URL: string;
    SHOW_BRM_TERMINAL_TRANSACTION_SUMMARY: boolean;
    SHOW_BRM_CARD_SALES_PERFORMANCE_UPDATE: boolean;
    SHOW_WITHHOLDING_TAX: boolean;
    SHOW_CASHOUT_FEE: boolean;
    HIDE_SIDEMENU_ON_MOBILE_APP: boolean;
    DISABLE_AUTO_LOGOUT_ON_MOBILE_APP: boolean;
    CARDS_DELIVERY_USE_CARD_SERVICE: boolean;
    SHOW_POS_WEB_HOOK: boolean;
    static USE_PROVISIONAL_OFFER_GENERATION_FLOW: boolean;
    SHOW_PROVISIONAL_OFFERS_LIST: boolean;
    SHOW_PROVISIONAL_OFFERS_CONTACT_US: boolean;
    SHOW_BRM_PENDING_LIST: boolean;
    ENABLE_MARKETER_ONBOARDING: boolean;
    SHOW_PROVISIONAL_OFFER_REPAYMENT_FREQUENCY: boolean;
    SHOW_PROVISIONAL_OFFER_LOAN_TENURE: boolean;
    USE_KYC_BVN_NATIONALITY: boolean;
    USE_BRM_KYC_BVN_NATIONALITY: boolean;
    SHOW_PROFILE_NAME_UPDATE_BUTTON: boolean;
    SHOW_PROFILE_DOB_NEW_UPDATE_BUTTON: boolean;
    SHOW_PROFILE_DOB_NEW_UPDATE_SECTION: boolean;
    ENABLE_PROFILE_UPDATE_BUTTON_KYC_LEVEL: number;
    SHOW_KFS_PROVISIONAL_OFFER: boolean;
    SHOW_LOAN_REQUEST_FLOW_TENURE: boolean;
    SHOW_LOAN_REQUEST_FLOW_REPAYMENT_FREQUENCY: boolean;
    SHOW_REPAYMENT_PLAN_PROVISIONAL_OFFER: boolean;
    SHOW_POS_INSURED_FLOW_V2: boolean;
    SHOW_BRM_INSURE_TERMINAL_FLOW: boolean;
    SHOW_INSURANCE_INFO: boolean;
    SHOW_CARD_DISTRIBUTION_EFFICIENCY_NEW_UI: boolean;
    SHOW_RETRIVE_BUTTON_CARD_DISTRIBUTION_EFFICIENCY_NEW_UI: boolean;
    HIDE_BO_KYC_LVL1_BACK_BUTTON: boolean;
    SHOW_INSURANCE_INFO_KFS: boolean;
    SHOW_DEVICES_MFE: boolean;
    SHOW_NOTIFICATION_PREFERENCE_MFE: boolean;
    SHOW_CONSENT_MANAGEMENT_MFE: boolean;
    SHOW_BUSINESS_TYPE_MFE: boolean;
    SHOW_LANGUAGE_MFE: boolean;
    SHOW_OTHERS_MFE: boolean;
    SHOW_TRANSFER_CONFIGURATION_MFE: boolean;
    SETTINGS_MFE_URL: string;
    PROFILE_SETUP_MFE_URL: string;
    SHOW_PROFILE_SETUP_MFE: boolean;
    static USE_NEW_LOAN_APP: boolean;
    SHOW_LOANS_DASHBOARD_WIDGET: boolean;
    static USE_NEW_LOAN_AGREEMENT_FLOW: boolean;
    LOANS_DASHBOARD_WIDGET_URL: string;
    LOANS_HOST_URL: string;
    LOANS_MARKUP_URL: string;
    LOANS_WCL_URL: string;
    LOANS_OVD_URL: string;
    LOANS_ASSETS_URL: string;
    LOANS_LOCALES_URL: string;
    TRANSFER_VALIDATION_FAILURE_MODAL_TITLE: string;
    SHOW_SAYT_V2: boolean;
    GROWTH_URL: string;
    GROWTH_V2_URL: string;
    USE_MONIEPOINT_MFB_LOGO: boolean;
    SHOW_LICENSED_AND_SECURED_INFO: boolean;
    USE_FIRST_LOAN_DISBURSAL_ACCOUNT: boolean;
    SHOW_BRM_ONBOARDING_PROOF_OF_ADDRESS: boolean;
    ALWAYS_SHOW_CM_INFO: boolean;
    SHOW_TERMINAL_ASSIGNMENT_TO_BACKOFFICE_CLEANUP: boolean;
    SHOW_TERMS_AND_CONDITION_CHECKBOX: boolean;
    SHOW_STAFF_PROFILE_UPDATE_BUTTON: boolean;
    SHOW_BRM_ONBOARDING_IDENTIFICATION: boolean;
    ENABLE_LOGIN_LOCATION_HEADERS: boolean;
    ENABLE_MANDATORY_LOGIN_LOCATION_ACCESS: boolean;
    SHOW_BUSINESS_BULK_INSURANCE_UPDATE: boolean;
    USE_NEW_BO_KYC_LEVEL3_V3_FLOW: boolean;
    OKHI_API_KEY: string;
    OKHI_BRANCH_ID: string;
    SHOW_FACE_VERIFICATION_IN_KYC_LVL3: boolean;
    SHOW_DISBURSEMENT_ACCOUNT_CONFIRMATION_MODAL: boolean;
    USE_NEW_PRIMARY_ACCOUNT_FLAG_ON_DISBURSEMENT_ACCOUNTS_ENDPOINT: boolean;
    SHOW_OVERDRAFT_MANUAL_REPAYMENT: boolean;
    USE_NEW_RENEWAL_SUBMISSION_ENDPOINT: boolean;
    MONIEPOINT_SAVINGS_V2_URL: string;
    S_CODE1: string;
    S_CODE2: string;
    static SHOW_CM_MENU_FOR_SC: boolean;
    static SHOW_CLUSTERS_MENU_FOR_SC: boolean;
    static SHOW_CM_MENU_FOR_RM: boolean;
    static SHOW_SC_MENU_FOR_RM: boolean;
    static SHOW_BRM_APPROVALS_MENU_FOR_CM: boolean;
    static SHOW_LIMIT_APPROVAL_MENU_FOR_CM: boolean;
    static SHOW_MY_COURSES_MENU_FOR_CM: boolean;
    static SHOW_PERFORMANCE_REPORTS_FOR_CM: boolean;
    static SHOW_PERFORMANCE_TRACKER_MENU_FOR_CM: boolean;
    GET_BRM_APPROVALS_PENDING_CLAIM_REQUESTS_FOR_CM: boolean;
    GET_BRM_APPROVALS_PROCESSING_CLAIM_REQUESTS_FOR_CM: boolean;
    GET_BRM_APPROVALS_TREATED_CLAIM_REQUESTS_FOR_CM: boolean;
    SHOW_BRM_APPROVALS_ACTION_COLUMN_FOR_CM: boolean;
    SHOW_BUSINESS_CATEGORY_UPDATE: boolean;
    UPDATE_BUSINESS_CATEGORY_URL: string;
    USE_ADDITIONAL_BUSINESS_KYC_LEVEL1: boolean;
    BRM_USE_ADDITIONAL_BUSINESS_KYC_LEVEL1: boolean;
    USE_MULTIPLE_BUSINESS_TYPES: boolean;
    SHOW_BRM_BUSINESS_TYPES: boolean;
    STORE_FRONT_IMAGE_MAX_SIZE: number;
    MAX_ALLOWED_BUSINESS_TYPES: number;
    ENABLE_LOCATION_DURING_PAYMENT: boolean;
    ENFORCE_LOCATION_DURING_PAYMENT: boolean;
    ACCOUNT_UPGRADE_MFE_URL: string;
    SHOW_ACCOUNT_UPGRADE_MFE: boolean;
    static SHOW_PARTNER_UPGRADE_MFE: boolean;
    USE_NEW_TERMINALS_ENDPOINT: boolean;
    SHOW_BRM_BUSINESS_RECATEGORIZATION_NOTIFICATION: boolean;
    SHOW_POS_TC: boolean;
    ENABLE_ONBOARDING_LOCATION_HEADERS: boolean;
    BUSINESSES_RM_AGENTS_TABLE_PAGE_SIZE: number;
    BUSINESSES_AGENTS_TABLE_PAGE_SIZE: number;
    USE_POLICY_DOCUMENTS_API: boolean;
    USE_FACETEC_LIVELINESS: boolean;
    USE_BRM_FACETEC_LIVELINESS: boolean;
    LIVELINESS_SERVICE_URL: string;
    MFE_CDN_IDENTITY_VERIFICATION_URL: string;
    ENABLE_ACCOUNTS_WALLET_TRANSACTIONS_FOR_CM: boolean;
    ENABLE_ACCOUNTS_HISTORICAL_TRANSACTIONS_FOR_CM: boolean;
    ENABLE_ACCOUNTS_CASHOUT_FOR_CM: boolean;
    static SHOW_TC_COMPLIANCE_DASHBOARD: boolean;
    USE_BRM_CREATE_BO_BUSINESS_PAGE: boolean;
    REMOVE_REFRESH_TOKEN_FOR_CM: boolean;
    REMOVE_CHECK_AUTH_FOR_CM: boolean;
    HIDE_BRM_PRM_SELF_ONBOARDING_ADDRESS_VERIFICATION: boolean;
    USE_NEW_BUSINESS_TYPES_UI: boolean;
    MARKETER_ONBOARDING_MFE_URL: string;
    static SHOW_MARKETER_ONBOARDING_MFE: boolean;
    USE_UPDATED_KYC_LIMITS_FLOW: boolean;
    SHOW_POS_TERMINAL_CONDITION_DETAIL_FOR_SC: boolean;
    MONIEPOINT_CONSENT_MANAGEMENT_URL: string;
    SHOW_PENDING_CONSENT_BANNER: boolean;
    SHOW_TERMINAL_SWAP_V4_UPDATE: boolean;
    USE_KYC_LVL_1_PREVENT_HYBRID_MERCHANT: boolean;
    USE_BRM_KYC_LVL_1_PREVENT_HYBRID_MERCHANT: boolean;
    USE_SOFT_ONBOARDING_PREVENT_HYBRID_MERCHANT: boolean;
    SHOW_SWAP_HISTORY: boolean;
    SHOW_QUOTA_FOR_NEW_TERMINALS_UPDATE: boolean;
    ENABLE_BRM_PRM_REQUEST_UPDATION: boolean;
    USE_UPDATED_CLUSTER_ASSIGNMENT_URL: boolean;
    ALLOW_SEARCH_BRM_CLUSTER_ASSIGNMENT: boolean;
    static USE_MFE_SC_TERMINAL_REQUESTS: boolean;
    SHOW_INVENTORY_STATUS_FILTER: boolean;

    load() {
        return new Promise((resolve, reject) => {
            /**
             * If this is true, application has been compiled and is being set from jar file.
             * Configurations have been injected into template.html using thymeleaf.
             */
            // tslint:disable-next-line:no-string-literal
            // const injectedConfig = window['inject']['CONFIG'] || '';
            // tslint:disable-next-line: no-string-literal
            const injectedConfig = window['inject'] || '';

            if (injectedConfig) {
                this.loadInjectedConfiguration().then(() => resolve(true));
            } else {
                /**
                 * App is being served using 'ng serve' or was build and is being run using 'ng build'.
                 * Then load configurations from config.ts file
                 */
                this.setConfiguration(CONFIG);
                resolve(true);
            }
        });
    }

    private loadInjectedConfiguration() {
        return new Promise((resolve, reject) => {
            // tslint:disable-next-line:no-string-literal
            const config = window['inject']['CONFIG'];
            StringHelper.explicitlyCastObjectStringValue(config);

            AppConfig.CLIENT_VERSION = config.CLIENT_VERSION || '0.0.0';
            this.USE_UNIFIED_PROVISIONAL_OFFER_FLOW = config.USE_UNIFIED_PROVISIONAL_OFFER_FLOW || false;

            this.ASSETS_HOST = config.assetUrl || '';
            this.MONIEPOINT_HOST = config.MONIEPOINT_HOST || '';
            this.MONIEPOINT_POS_ERP_INTEGRATION = config.MONIEPOINT_POS_ERP_INTEGRATION || '';
            this.MONIEBOOK_ENV_URL = config.MONIEBOOK_ENV_URL || '';
            this.MONIEPOINT_USER_URL = config.MONIEPOINT_USER_URL || '';
            this.MONIEPOINT_WORKFLOW_URL = config.MONIEPOINT_WORKFLOW_URL || '';
            this.MONIEPOINT_SAVINGS = config.MONIEPOINT_SAVINGS;
            this.MONIEPOINT_LOANS = config.MONIEPOINT_LOANS;
            this.WLC_MANAGEMENT = config.WLC_MANAGEMENT;
            this.LOAN_GATEWAY_SERVICE_URL = config.LOAN_GATEWAY_SERVICE_URL;
            this.WCL_PORTFOLIO_MANAGEMENT = config.WCL_PORTFOLIO_MANAGEMENT;
            this.LMS_SERVICE_URL = config.LMS_SERVICE_URL;
            this.MARKUP_SERVICE_URL = config.MARKUP_SERVICE_URL;
            this.WCL_SERVICE_URL_V2 = config.WCL_SERVICE_URL_V2;
            this.OVD_SERVICE_URL_V2 = config.OVD_SERVICE_URL_V2;
            this.ENABLE_WCL_COMBINED_GUARANTOR_SUBMISSION = config.ENABLE_WCL_COMBINED_GUARANTOR_SUBMISSION;
            this.ENABLE_WCL_PLATFORM_HTTP_HEADER = config.ENABLE_WCL_PLATFORM_HTTP_HEADER;
            this.USE_WCL_BUSINESS_OWNER_REPAYMENT_ACCOUNTS = config.USE_WCL_BUSINESS_OWNER_REPAYMENT_ACCOUNTS;
            this.USE_WCL_BUSINESS_OWNER_DISBURSEMENT_ACCOUNTS = config.USE_WCL_BUSINESS_OWNER_DISBURSEMENT_ACCOUNTS;
            this.USE_WCL_BUSINESS_ADDRESS_VERIFICATION_V2 = config.USE_WCL_BUSINESS_ADDRESS_VERIFICATION_V2;
            this.ENABLE_WCL_GEOLOCATION_HIGH_ACCURACY = config.ENABLE_WCL_GEOLOCATION_HIGH_ACCURACY;
            AppConfig.SHOW_WCL_IN_BUSINESS_USER_DASHBOARD = config.SHOW_WCL_IN_BUSINESS_USER_DASHBOARD;
            AppConfig.SHOW_OVERDRAFT_RUNNING_LOANS_V2 = config.SHOW_OVERDRAFT_RUNNING_LOANS_V2;
            this.SHOW_OVERDRAFT_RUNNING_LOANS_V2_SALES_VALUE = config.SHOW_OVERDRAFT_RUNNING_LOANS_V2_SALES_VALUE;
            this.SHOW_LOAN_PRODUCT_SELECTION_FLOW = config.SHOW_LOAN_PRODUCT_SELECTION_FLOW;
            this.USE_OVD_NEW_AGREEMENT_FLOW = config.USE_OVD_NEW_AGREEMENT_FLOW;
            this.SHOW_OVERDRAFT_RUNNING_LOANS_V2_LEARN_ABOUT_OVERDRAFT = config.SHOW_OVERDRAFT_RUNNING_LOANS_V2_LEARN_ABOUT_OVERDRAFT;
            this.SHOW_OVERDRAFT_RUNNING_LOANS_V2_DEACTIVATE_OVERDRAFT = config.SHOW_OVERDRAFT_RUNNING_LOANS_V2_DEACTIVATE_OVERDRAFT;
            AppConfig.SHOW_WCL_BUSINESS_USER_DASHBOARD_NEW_BADGE = config.SHOW_WCL_BUSINESS_USER_DASHBOARD_NEW_BADGE;
            AppConfig.SHOW_PERFORMANCE_TRACKER_FOR_RM_SC = config.SHOW_PERFORMANCE_TRACKER_FOR_RM_SC;
            this.MONIEPOINT_CARDS = config.MONIEPOINT_CARDS;
            this.MONIEPOINT_OFFLINE_PAYMENT = config.MONIEPOINT_OFFLINE_PAYMENT;
            this.MONIEPOINT_OFFLINE_SALES_URL = config.MONIEPOINT_OFFLINE_SALES_URL || '';
            this.MONIEPOINT_TERMINAL_INVENTORY = config.MONIEPOINT_TERMINAL_INVENTORY || '';
            this.MONIEPOINT_INSURANCE = config.MONIEPOINT_INSURANCE;
            this.MONIEPOINT_ACCOUNTING = config.MONIEPOINT_ACCOUNTING || '';
            this.MONIEPOINT_ACCOUNTING_STAGING = config.MONIEPOINT_ACCOUNTING_STAGING || '';
            this.MONIEPOINT_ACCOUNTS = config.MONIEPOINT_ACCOUNTS || '';
            this.MONIEPOINT_FV_CORE = config.MONIEPOINT_FV_CORE || '';
            this.MONIEPOINT_WITHDRAWAL = config.MONIEPOINT_WITHDRAWAL;
            this.MONIEPOINT_DEPOSIT = config.MONIEPOINT_DEPOSIT;
            this.MONIEPOINT_AREA = config.MONIEPOINT_AREA;
            this.MONIEPOINT_LOGISTICS = config.MONIEPOINT_LOGISTICS;
            this.MONIEPOINT_REPORT = config.MONIEPOINT_REPORT;
            this.MONIEPOINT_BILL_PAYMENT = config.MONIEPOINT_BILL_PAYMENT;
            this.MONIEPOINT_GAMIFICATION = config.MONIEPOINT_GAMIFICATION;
            this.MONIEPOINT_REFERRALS_CASHOUT_SERVICE = config.MONIEPOINT_REFERRALS_CASHOUT_SERVICE;
            this.MONIEPOINT_DASHBOARD = config.MONIEPOINT_DASHBOARD;
            this.GRAFANA_URL = config.GRAFANA_URL;
            this.REDIRECT_LOGIN_USER_TYPE = config.REDIRECT_LOGIN_USER_TYPE;
            this.REDIRECT_ACCESS_TOKEN = config.REDIRECT_ACCESS_TOKEN;
            this.MONIEPOINT_MFA_LOOM = config.MONIEPOINT_MFA_LOOM;
            config.REDIRECT_ACCESS_TOKEN = null;
            this.mock = config.mock || false;
            this.DOMAIN_ID = config.DOMAIN_ID || 'MONIEPOINT';
            this.SHOW_MOBILE_WEB_VIEW = config.SHOW_MOBILE_WEB_VIEW || false;
            this.DEFAULT_OTP_COUNT_DOWN = config.DEFAULT_OTP_COUNT_DOWN || 600;
            this.appTimeout = config.APP_TIMEOUT;
            this.clientId = config.CLIENT_ID || 'WEB';
            this.allowAgentLogin = config.ALLOW_AGENT_LOGIN;
            this.KUWEGO_URL = config.KUWEGO_URL;
            this.KUWEGO_IMAGE_URL = config.KUWEGO_IMAGE_URL;
            this.KUWEGO_LOANS = config.KUWEGO_LOANS;
            this.FILE_SERVICE = config.FILE_SERVICE;
            this.FVS_FILE_SERVICE = config.FVS_FILE_SERVICE;
            this.SHOW_COMPLIANCE_VIEW = config.SHOW_COMPLIANCE_VIEW || false;
            this.ALLOW_POS_REQUEST = config.ALLOW_POS_REQUEST || false;
            this.SHOW_CONSOLIDATION_VIEW = config.SHOW_CONSOLIDATION_VIEW || false;
            this.ALLOW_SIGN_UP = config.ALLOW_SIGN_UP || false;
            this.MONIEPOINT_NOTIFICATION = config.MONIEPOINT_NOTIFICATION;
            this.SHOW_TRAINING_VIEW = config.SHOW_TRAINING_VIEW || false;
            this.MONIEPOINT_ONBOARDING = config.MONIEPOINT_ONBOARDING;
            this.MONIEPOINT_AVS = config.MONIEPOINT_AVS;
            this.MONIEPOINT_TERMINAL = config.MONIEPOINT_TERMINAL || '';
            this.SHOW_NEW_SETTING_VIEW = config.SHOW_NEW_SETTING_VIEW || false;
            this.SHOW_FEE_WAIVER = config.SHOW_FEE_WAIVER || false;
            this.SHOW_CAPITAL_LOANS_MENU = config.SHOW_CAPITAL_LOANS_MENU || false;
            this.SHOW_CAPITAL_LOANS_WEB = config.SHOW_CAPITAL_LOANS_WEB || false;
            this.SHOW_DOWNLOAD_POS_ACCOUNT_DETAILS = config.SHOW_DOWNLOAD_POS_ACCOUNT_DETAILS || false;
            this.ALLOW_KYC = config.ALLOW_KYC || false;
            this.SHOW_RE_ACT_LINK_ONBOARDING_BO = config.SHOW_RE_ACT_LINK_ONBOARDING_BO || false;
            this.META_MAP_FLOW_ID = config.META_MAP_FLOW_ID || '62ea31664733dc001d80f9ac';
            this.META_MAP_LOW_LEVEL_ACCOUNT_FLOW_ID = config.META_MAP_LOW_LEVEL_ACCOUNT_FLOW_ID || '63bd31422afaa3001c941354';
            this.META_MAP_PERSONAL_INFO_FLOW_ID = config.META_MAP_PERSONAL_INFO_FLOW_ID || '636b748264ac5e001d8f6aac';
            this.SHOW_KYC_REGISTERED_BUSINESS = config.SHOW_KYC_REGISTERED_BUSINESS || false;
            this.SHOW_POS_REQUEST_MENU = config.SHOW_POS_REQUEST_MENU || false;
            this.SHOW_CARDS_MENU = config.SHOW_CARDS_MENU || false;
            this.SHOW_SUPPORT = config.SHOW_SUPPORT || false;
            this.SHOW_CASHOUT_BUTTON = config.SHOW_CASHOUT_BUTTON || false;
            this.SHOW_TRANSACTION_SHARE_BUTTON = config.SHOW_TRANSACTION_SHARE_BUTTON || false;
            this.SHOW_BRM_DASHBOARD_V2 = config.SHOW_BRM_DASHBOARD_V2 || false;
            this.SHOW_WRITEOFF_PROMOTION = config.SHOW_WRITEOFF_PROMOTION || false;
            this.BUFFER_SIZE = config.BUFFER_SIZE || 1000;
            this.LOG_TIMEOUT = config.LOG_TIMEOUT || 60000;
            this.MONIEPOINT_URL = config.MONIEPOINT_URL || 'https://moniepoint.development.teamapt.com';
            this.SHOW_YEARLY_SUMMARY_REPORT = config.SHOW_YEARLY_SUMMARY_REPORT || false;
            this.SHOW_TERMS_AND_CONDITIONS_MODAL_BO = config.SHOW_TERMS_AND_CONDITIONS_MODAL_BO || false;
            this.SHOW_TERMS_AND_CONDITIONS_MODAL_BRM = config.SHOW_TERMS_AND_CONDITIONS_MODAL_BRM || false;
            this.SHOW_TERMS_AND_CONDITIONS_MODAL_RM = config.SHOW_TERMS_AND_CONDITIONS_MODAL_RM || false;
            this.SHOW_TERMS_AND_CONDITIONS_MODAL_SC = config.SHOW_TERMS_AND_CONDITIONS_MODAL_SC || false;
            this.SHOW_SWITCH_TO_REG_BUSINESS = config.SHOW_SWITCH_TO_REG_BUSINESS || false;
            this.SHOW_DASHBOARD_ALERT_WIDGET = config.SHOW_DASHBOARD_ALERT_WIDGET || false;
            this.SHOW_BRM_CASHOUT_PIN_FLOW = config.SHOW_BRM_CASHOUT_PIN_FLOW || false;
            (this.JWT_EXPIRY_CHECK = config.JWT_EXPIRY_CHECK || 60000), resolve(true);
            this.SHOW_BRM_WRITEOFF_ACTION = config.SHOW_BRM_WRITEOFF_ACTION || false;
            this.SHOW_BRM_RESET_PIN_FLOW = config.SHOW_BRM_RESET_PIN_FLOW || false;
            this.SHOW_BUSINESS_EFFICIENCY_UPDATE = config.SHOW_BUSINESS_EFFICIENCY_UPDATE || false;
            this.META_MAP_BRM_PROFLIE_VERIFICATION_LIVELINESS_FLOW_ID =
                config.META_MAP_BRM_PROFLIE_VERIFICATION_LIVELINESS_FLOW_ID || '63b3e2aa78cbe0001c640748';
            this.SHOW_BRM_VERIFICATION_METAMAP_LIVELINESS_FLOW = config.SHOW_BRM_VERIFICATION_METAMAP_LIVELINESS_FLOW || false;
            this.SHOW_EOD_PRINTING = config.SHOW_EOD_PRINTING || false;
            this.SHOW_SELF_TEST = config.SHOW_SELF_TEST || false;
            this.SHOW_STAFF_USERS_MENU = config.SHOW_STAFF_USERS_MENU || false;
            this.SHOW_STAFF_DESIGNATION_MENU = config.SHOW_STAFF_DESIGNATION_MENU || false;
            this.SHOW_TERMINAL_ASSIGNMENT_UPDATE = config.SHOW_TERMINAL_ASSIGNMENT_UPDATE || false;
            this.USE_V2_SELECTION_PAGE = config.USE_V2_SELECTION_PAGE || false;
            this.RM_ONBOARDING_URL = config.RM_ONBOARDING_URL || 'https://rm.onboarding.mab.development.teamapt.com';
            this.SHOW_ONBOARDING_SUPPORT = config.SHOW_ONBOARDING_SUPPORT || false;
            this.SHOW_COURSES_WARNING_ON_CASHOUT = config.SHOW_COURSES_WARNING_ON_CASHOUT || false;
            this.STAFF_USER_DEPOSIT_REQUEST = config.STAFF_USER_DEPOSIT_REQUEST || false;
            this.STAFF_USER_AIRTIME_REQUEST = config.STAFF_USER_AIRTIME_REQUEST || false;
            this.STAFF_USER_BILL_PAYMENT_REQUEST = config.STAFF_USER_BILL_PAYMENT_REQUEST || false;
            this.SHOW_RECURRING_TRANSFER_LIMIT = config.SHOW_RECURRING_TRANSFER_LIMIT || false;
            this.SHOW_INFINITE_RECURRING_TRANSFER = config.SHOW_INFINITE_RECURRING_TRANSFER || false;
            this.SHOW_BO_NEW_APPROVALS_UI = config.SHOW_BO_NEW_APPROVALS_UI || false;
            this.SHOW_BO_DEFAULT_APPROVAL_UI_NEW = config.SHOW_BO_DEFAULT_APPROVAL_UI_NEW || false;
            this.SHOW_APP_DOWNLOAD_BANNER = config.SHOW_APP_DOWNLOAD_BANNER || false;
            this.USE_NEW_ONBOARDING_FLOW = config.USE_NEW_ONBOARDING_FLOW || false;
            this.MONIEPOINT_ORCHESTRATOR_SERVICE =
                config.MONIEPOINT_ORCHESTRATOR_SERVICE || 'https://notification-orchestrator.development.moniepoint.com';
            this.USE_NEW_SIGN_UP_FLOW = config.USE_NEW_SIGN_UP_FLOW || false;
            this.USE_NEW_KYC_FLOW = config.USE_NEW_KYC_FLOW || false;
            this.SHOW_NOTIFICATION_PREFERENCE = config.SHOW_NOTIFICATION_PREFERENCE || '';
            this.SHOW_DOWNLOADABLE_MATERIAL = config.SHOW_DOWNLOADABLE_MATERIAL || false;
            this.SHOW_NEW_ACCOUNT_VIEW = config.SHOW_NEW_ACCOUNT_VIEW || false;
            this.SHOW_NEW_TRANSFER = config.SHOW_NEW_TRANSFER || false;
            this.SHOW_TRANSFER_LIMIT_MODAL = config.SHOW_TRANSFER_LIMIT_MODAL || false;
            this.REMOVE_TRANSFER_ALL_TRANSACTIONS = config.REMOVE_TRANSFER_ALL_TRANSACTIONS || false;
            this.SHOW_NEW_TRANSFER_EXPORT_URL = config.SHOW_NEW_TRANSFER_EXPORT_URL || false;
            this.ROUTE_TO_DASHBOARD_AFTER_ONBOARDING = config.ROUTE_TO_DASHBOARD_AFTER_ONBOARDING || false;
            this.USE_MOBILE_MAX_FILE_SIZE = config.USE_MOBILE_MAX_FILE_SIZE || false;
            this.DEFAULT_TIME_FOR_METAMAP_STATUS_CALL = config.DEFAULT_TIME_FOR_METAMAP_STATUS_CALL || 60;
            this.SET_DEFAULT_NOTIFICATION_PREFERENCE = config.SET_DEFAULT_NOTIFICATION_PREFERENCE || false;
            this.SHOW_LOGIN_USSD = config.SHOW_LOGIN_USSD || false;
            this.USE_NEW_META_MAP_BUTTON = config.USE_NEW_META_MAP_BUTTON || false;
            this.SHOW_TERMINAL_ASSIGNMENT_BUSINESS_UPDATE = config.SHOW_TERMINAL_ASSIGNMENT_BUSINESS_UPDATE || false;
            AppConfig.SHOW_BRM_APPROVE_TAB = config.SHOW_BRM_APPROVE_TAB || false;
            AppConfig.SHOW_BRM_ONBOARDING_FOR_CM = config.SHOW_BRM_ONBOARDING_FOR_CM || false;
            AppConfig.SHOW_DOCUMENT_APPROVE_TAB = config.SHOW_DOCUMENT_APPROVE_TAB || false;
            AppConfig.SHOW_LIMIT_APPROVE_TAB = config.SHOW_LIMIT_APPROVE_TAB || false;
            AppConfig.SHOW_BRM_BUSINESS_ACCOUNT = config.SHOW_BRM_BUSINESS_ACCOUNT || false;
            AppConfig.SHOW_BUSINESS_EARNINGS = config.SHOW_BUSINESS_EARNINGS || false;
            AppConfig.SHOW_BRM_ONBOARDING = config.SHOW_BRM_ONBOARDING || false;
            AppConfig.SHOW_ALL_COMMISSIONS = config.SHOW_ALL_COMMISSIONS || false;
            AppConfig.TRACK_EVENT = config.TRACK_EVENT || false;
            AppConfig.SHOW_BUSINESS_ACCOUNT_CASHOUT_BUTTON = config.SHOW_BUSINESS_ACCOUNT_CASHOUT_BUTTON || false;
            AppConfig.CAN_SHOW_PARTNERS_DEPOSIT_COMMISSIONS_BALANCE = config.CAN_SHOW_PARTNERS_DEPOSIT_COMMISSIONS_BALANCE || false;
            this.HIDE_BUSINESSES_FOR_INVITE_ADMIN = config.HIDE_BUSINESSES_FOR_INVITE_ADMIN || false;
            this.SHOW_NEW_FLOW_INVITE_STAFF = config.SHOW_NEW_FLOW_INVITE_STAFF || false;
            this.EXTENDED_STATEMENT_DOWNLOAD = config.EXTENDED_STATEMENT_DOWNLOAD || false;
            this.BUSINESS_OWNER_EXTENDED_STATEMENT_DOWNLOAD = config.BUSINESS_OWNER_EXTENDED_STATEMENT_DOWNLOAD || false;
            this.DAILY_BUSINESS_STATEMENT_DOWNLOAD = config.DAILY_BUSINESS_STATEMENT_DOWNLOAD || false;
            this.DAILY_TERMINAL_STATEMENT_DOWNLOAD = config.DAILY_TERMINAL_STATEMENT_DOWNLOAD || false;
            this.SHOW_BUSINESS_OWNER_STATEMENT_EXPORT = config.SHOW_BUSINESS_OWNER_STATEMENT_EXPORT || false;
            this.SHOW_KYC_LEVEL_BANNER = config.SHOW_KYC_LEVEL_BANNER || false;
            this.SHOW_USER_PIN_MENU = config.SHOW_USER_PIN_MENU || false;
            this.ENABLE_STAFF_USER_INVITE = config.ENABLE_STAFF_USER_INVITE || false;
            this.MONIEPOINT_CRM_SERVICE = config.MONIEPOINT_CRM_SERVICE || 'https://moniepoint-crm-service.development.teamapt.com';
            this.SHOW_CARD_PENETRATION_WIDGET = config.SHOW_CARD_PENETRATION_WIDGET || false;
            this.SHOW_OLD_TRANSACTION_PIN_MENU = config.SHOW_OLD_TRANSACTION_PIN_MENU || false;
            this.USE_NEW_TRANSACTION_PIN = config.USE_NEW_TRANSACTION_PIN || false;
            this.SHOW_KYC_TRANSACTION_LIMITS = config.SHOW_KYC_TRANSACTION_LIMITS || false;
            AppConfig.USE_NEW_WITHDRAWAL = config.USE_NEW_WITHDRAWAL || false;
            AppConfig.USE_NEW_PURCHASE = config.USE_NEW_PURCHASE || false;
            this.SHOW_USER_PIN_MODAL_ON_BO_LOGIN = config.SHOW_USER_PIN_MODAL_ON_BO_LOGIN || false;
            this.SHOW_SC_TERMINAL_ASSIGNMENT = config.SHOW_SC_TERMINAL_ASSIGNMENT || false;
            this.USE_CONSOLIDATED_ALL_FOR_ALL_TRANSACTIONS = config.USE_CONSOLIDATED_ALL_FOR_ALL_TRANSACTIONS || false;
            this.SHOW_BO_DASHBOARD_FOR_DIGITAL_BO = config.SHOW_BO_DASHBOARD_FOR_DIGITAL_BO || false;
            this.CAN_OPEN_BO_DIGITAL_ACCOUNT = config.CAN_OPEN_BO_DIGITAL_ACCOUNT || false;
            this.CARDS_CAN_USE_USER_PIN = config.CARDS_CAN_USE_USER_PIN || false;
            this.MONIEPOINT_DELIVERY_SERVICE = config.MONIEPOINT_DELIVERY_SERVICE;
            this.CAN_USE_DELIVERY_SERVICE = config.CAN_USE_DELIVERY_SERVICE || false;
            this.SHOW_BO_TABLE_V2 = config.SHOW_BO_TABLE_V2 || false;
            this.SHOW_POS_UPDATE = config.SHOW_POS_UPDATE || false;
            this.SHOW_SWAP_TERMINAL_UPDATE = config.SHOW_SWAP_TERMINAL_UPDATE || false;
            this.CAN_USE_SUBLGA = config.CAN_USE_SUBLGA || false;
            this.CAN_BRM_EXTEND_GRACE_PERIOD_AFTER_EXPIRATION = config.CAN_BRM_EXTEND_GRACE_PERIOD_AFTER_EXPIRATION || false;
            this.TIME_ZONE = config.TIME_ZONE || 'Africa/Lagos';
            this.WEB_BICON = config.WEB_BICON || true;
            this.USE_KYC_API_ON_DASHBOARD = config.USE_KYC_API_ON_DASHBOARD || false;
            this.SHOW_TERMINAL_COMMISSION_FEE_SPLIT = config.SHOW_TERMINAL_COMMISSION_FEE_SPLIT || false;
            this.USE_NEW_LOGIN_API = config.USE_NEW_LOGIN_API || false;
            this.CAN_ADD_BUSINESSES_FOR_PENDING_BO = config.CAN_ADD_BUSINESSES_FOR_PENDING_BO || false;
            this.CAN_USE_SOFT_ONBOARDING = config.CAN_USE_SOFT_ONBOARDING || false;
            this.CARDS_CAN_COLLECT_CARDS = config.CARDS_CAN_COLLECT_CARDS || false;
            this.SHOW_PROFILE_BUTTON_ON_BO_PROFILE = config.SHOW_PROFILE_BUTTON_ON_BO_PROFILE || false;
            this.USE_UUID_FOR_DEVICE_ID = config.USE_UUID_FOR_DEVICE_ID || false;
            this.USE_NIBSS_BVN_VERIFICATION = config.USE_NIBSS_BVN_VERIFICATION || false;
            this.USE_NEW_STATEMENT_FLOW = config.USE_NEW_STATEMENT_FLOW || false;
            this.USE_OTP_CHANGE_PASSWORD_AND_PIN = config.USE_OTP_CHANGE_PASSWORD_AND_PIN || false;
            this.USE_NEW_CHANGE_PASSWORD = config.USE_NEW_CHANGE_PASSWORD || false;
            this.USE_NEW_RESET_USER_PIN = config.USE_NEW_RESET_USER_PIN || false;
            this.SHOULD_USE_NEW_BVN_FLOW = config.SHOULD_USE_NEW_BVN_FLOW || false;
            this.SHOW_BRM_CARD_SALES_AGENT = config.SHOW_BRM_CARD_SALES_AGENT || false;
            this.SHOW_BRM_CARD_NEW_UI = config.SHOW_BRM_CARD_NEW_UI || false;
            this.SHOW_SC_TERMINAL_SWAP = config.SHOW_SC_TERMINAL_SWAP || false;
            this.USE_OLD_BUSINESS_OWNER_KYC = config.USE_OLD_BUSINESS_OWNER_KYC || false;
            this.HIDE_PDF_STATEMENT_DOWNLOAD = config.HIDE_PDF_STATEMENT_DOWNLOAD || false;
            this.USE_NEW_BO_STATEMENT_DOWNLOAD = config.USE_NEW_BO_STATEMENT_DOWNLOAD || false;
            this.CAN_USE_BUSINESS_NAME_CHANGE = config.CAN_USE_BUSINESS_NAME_CHANGE || false;
            AppConfig.SHOW_REFERRALS = config.SHOW_REFERRALS || false;
            AppConfig.SHOULD_SHOW_REWARDS_V2 = config.SHOULD_SHOW_REWARDS_V2 || false;
            AppConfig.SHOULD_USE_UNIFIED_BANNER = config.SHOULD_USE_UNIFIED_BANNER || false;
            this.SHOW_REFERRALS_CASHOUT = config.SHOW_REFERRALS_CASHOUT || false;
            this.SHOW_BULK_TRANSFER = config.SHOW_BULK_TRANSFER || false;
            this.ADD_BUSINESS_DETAILS_MENU = config.ADD_BUSINESS_DETAILS_MENU || false;
            this.SHOW_POS_ERP_INTEGRATION = config.SHOW_POS_ERP_INTEGRATION || false;
            this.CAN_USE_SMILE_ID = config.CAN_USE_SMILE_ID || false;
            this.USE_OVERDRAFT_PAYMENT = config.USE_OVERDRAFT_PAYMENT || false;
            this.SHOW_COLLECT_CARD_MENU = config.SHOW_COLLECT_CARD_MENU || false;
            AppConfig.SHOW_NEW_TERMINAL_ASSIGNMENT_REQUESTS = config.SHOW_NEW_TERMINAL_ASSIGNMENT_REQUESTS || false;
            this.SHOW_ACCOUNT_CLOSURE = config.SHOW_ACCOUNT_CLOSURE || false;
            this.SHOW_BRM_PUSH_CARDS_TO_SALES_AGENT = config.SHOW_BRM_PUSH_CARDS_TO_SALES_AGENT || false;
            this.MONIEPOINT_APPLICATION_STORE_URL = config.MONIEPOINT_APPLICATION_STORE_URL || '';
            this.REFERRAL_PRE_REGISTRATION_API_RETRY_COUNT = config.REFERRAL_PRE_REGISTRATION_API_RETRY_COUNT || 10;
            this.REFERRAL_PRE_REGISTRATION_API_RETRY_INTERVAL = config.REFERRAL_PRE_REGISTRATION_API_RETRY_INTERVAL || 2000;
            this.BRM_PUSH_TO_SALES_AGENT_CARD_COUNT = config.BRM_PUSH_TO_SALES_AGENT_CARD_COUNT || 5;
            this.BRM_CAN_RETRIEVE_CARDS = config.BRM_CAN_RETRIEVE_CARDS || false;
            this.SHOW_NEW_PROFILE_UPDATE_VIEW = config.SHOW_NEW_PROFILE_UPDATE_VIEW || false;
            this.USE_KYC_NIN_FLOW = config.USE_KYC_NIN_FLOW || false;
            this.BRM_CAN_USE_FLEXIBLE_CARD_COST = config.BRM_CAN_USE_FLEXIBLE_CARD_COST || false;
            this.USE_BRM_KYC_NIN_FLOW = config.USE_BRM_KYC_NIN_FLOW || false;
            this.CAN_USE_IDENTITY_TOKEN = config.CAN_USE_IDENTITY_TOKEN || false;
            this.USE_LOGIN_OPTION = config.USE_LOGIN_OPTION || false;
            this.CAN_CHANGE_PASSCODE = config.CAN_CHANGE_PASSCODE || false;
            this.SHOW_SIGN_UP_PASSCODE_FLOW = config.SHOW_SIGN_UP_PASSCODE_FLOW || false;
            this.USE_CARD_PUSH_BATCH_SETTINGS = config.USE_CARD_PUSH_BATCH_SETTINGS || false;
            this.SHOW_USSD_BANKING_CHANNEL_SETTINGS = config.SHOW_USSD_BANKING_CHANNEL_SETTINGS || false;
            this.USSD_BANKING_CHANNEL_MODAL_MAXIMUM_USERS = config.USSD_BANKING_CHANNEL_MODAL_MAXIMUM_USERS || 5;
            this.USE_NEW_FORGET_PASSCODE_FLOW = config.USE_NEW_FORGET_PASSCODE_FLOW || false;
            this.USE_ACCOUNT_NUMBER_ALIAS = config.USE_ACCOUNT_NUMBER_ALIAS || false;
            this.VALIDATE_DUPLICATE_TRANSFERS = config.VALIDATE_DUPLICATE_TRANSFERS || false;
            this.SHOW_TERMINAL_TRANSACTION_WIDGET = config.SHOW_TERMINAL_TRANSACTION_WIDGET || true;
            this.SHOW_CARD_SALES_SUMMARY = config.SHOW_CARD_SALES_SUMMARY || true;
            this.USE_NEW_KYC_LEVEL2_FLOW = config.USE_NEW_KYC_LEVEL2_FLOW || false;
            this.USE_NEW_KYC_LEVEL3_FLOW = config.USE_NEW_KYC_LEVEL3_FLOW || false;
            this.BRM_CAN_USE_CONFIG_FLEXIBLE_CARD_COST = config.BRM_CAN_USE_CONFIG_FLEXIBLE_CARD_COST || false;
            this.CAN_HIDE_KYC_LEVEL1_PRIMER = config.CAN_HIDE_KYC_LEVEL1_PRIMER || false;
            this.USE_NEW_BRM_KYC_LEVEL2_FLOW = config.USE_NEW_BRM_KYC_LEVEL2_FLOW || false;
            this.USE_NEW_BRM_KYC_LEVEL3_FLOW = config.USE_NEW_BRM_KYC_LEVEL2_FLOW || false;
            this.REWARD_SERVICE_URL = config.REWARD_SERVICE_URL || 'https://moniepoint-rewards-service.development.moniepoint.com';
            this.SHOULD_SHOW_REWARDS = config.SHOULD_SHOW_REWARDS || false;
            this.SHOW_TERMINAL_ACTIVITY_SCORE = config.SHOW_TERMINAL_ACTIVITY_SCORE || false;
            this.USE_PROFILE_SETUP = config.USE_PROFILE_SETUP || false;
            this.USE_CARD_DEVICE_ID = config.USE_CARD_DEVICE_ID || false;
            this.USSD_BANKING_CODE = config.USSD_BANKING_CODE || '*5573#';
            this.USE_STAFF_USER_REFRESH_TOKEN = config.USE_STAFF_USER_REFRESH_TOKEN || false;
            this.CAN_RESEND_OTP_VIA_WHATSAPP = config.CAN_RESEND_OTP_VIA_WHATSAPP || false;
            this.USE_LOAN_EXPIRED_V2 = config.USE_LOAN_EXPIRED_V2 || false;
            this.USE_PENDING_LOAN_TIMELINE_V2 = config.USE_PENDING_LOAN_TIMELINE_V2 || false;
            this.CAN_USE_NEW_USSD = config.CAN_USE_NEW_USSD || false;
            this.SHOW_BO_PERFORMANCE = config.SHOW_BO_PERFORMANCE || false;
            this.USE_KAMONA_SIGN_IN = config.USE_KAMONA_SIGN_IN || false;
            this.SHOW_CAC_BANNER = config.SHOW_CAC_BANNER || false;
            this.SHOW_BRM_CAC_INCOMPLIANT_BO = config.SHOW_BRM_CAC_INCOMPLIANT_BO || false;
            this.USE_DEVICE_ID_DECRYPTION = config.USE_DEVICE_ID_DECRYPTION || false;
            this.USE_ASYNC_LIVELINESS_CHECK = config.USE_ASYNC_LIVELINESS_CHECK || false;
            this.SHOW_UPDATE_DATE_OF_BIRTH = config.SHOW_UPDATE_DATE_OF_BIRTH || false;
            AppConfig.SHOW_LOAN_PREQUALIFICATION_AGGREGATORS = config.SHOW_LOAN_PREQUALIFICATION_AGGREGATORS || false;
            AppConfig.SHOW_LOAN_PREQUALIFICATION_RC = config.SHOW_LOAN_PREQUALIFICATION_RC || false;
            AppConfig.SHOW_LOAN_AGGREGATORS_PREQUALIFICATION_LOOKUP = config.SHOW_LOAN_AGGREGATORS_PREQUALIFICATION_LOOKUP || false;
            AppConfig.SHOW_LOAN_AGGREGATORS_PREQUALIFICATION_LOOKUP_V2 = config.SHOW_LOAN_AGGREGATORS_PREQUALIFICATION_LOOKUP_V2 || false;
            this.USE_PREQUALIFIED_BOS_V2 = config.USE_PREQUALIFIED_BOS_V2 || false;
            this.USE_PREQUALIFICATION_LOOKUP_V2 = config.USE_PREQUALIFICATION_LOOKUP_V2 || false;
            AppConfig.SHOW_LOAN_AGGREGATORS_SCHEDULE_SIMULATION = config.SHOW_LOAN_AGGREGATORS_SCHEDULE_SIMULATION || false;
            this.FO_ENVIRONMENT = config.FO_ENVIRONMENT || 'local';
            this.TELEMETRY_ENABLE = config.TELEMETRY_ENABLE ?? false;
            this.TELEMETRY_BASE_URL = config.TELEMETRY_BASE_URL ?? 'https://hermes-ingest.moniepointinc.com/v1';
            this.TELEMETRY_SERVICE_NAME = config.TELEMETRY_SERVICE_NAME ?? 'moniepoint-frontoffice-web';
            this.TELEMETRY_DEBUG_MODE = config.TELEMETRY_DEBUG_MODE ?? false;
            this.TELEMETRY_DEV_MODE = config.TELEMETRY_DEV_MODE ?? false;
            this.TELEMETRY_INTERVAL_MILLIS = config.TELEMETRY_INTERVAL_MILLIS ?? 20_000;
            this.SHOW_INCOMPLIANT_KYC_BANNER = config.SHOW_INCOMPLIANT_KYC_BANNER || false;
            this.SHOW_BRM_INCOMPLIANT_KYC_BANNER = config.SHOW_BRM_INCOMPLIANT_KYC_BANNER || false;
            this.USE_AUTO_ADDRESS_APPROVAL = config.USE_AUTO_ADDRESS_APPROVAL || false;
            this.CARDS_REQUIRE_TERMS_AND_CONDITIONS = config.CARDS_REQUIRE_TERMS_AND_CONDITIONS || false;
            AppConfig.SHOW_INVENTORY = config.SHOW_INVENTORY || false;
            this.ENABLE_LIVENESS_FOR_CARD_ACTIVATION = config.ENABLE_LIVENESS_FOR_CARD_ACTIVATION || false;
            this.CARD_TOOLS_UI_UPDATE_V1 = config.CARD_TOOLS_UI_UPDATE_V1 || false;
            this.USE_MERGE_DUPLICATE_PROFILE_FLOW = config.USE_MERGE_DUPLICATE_PROFILE_FLOW ?? true;
            this.ALLOW_SIGN_UP_FOR_BRM = config.ALLOW_SIGN_UP_FOR_BRM || false;
            this.ALLOW_BRM_ADD_BUSINESS = config.ALLOW_BRM_ADD_BUSINESS || false;
            this.ALLOW_BRM_USE_PASSPORT_PHOTOGRAPH_FOR_BO_ONBOARDING = config.ALLOW_BRM_USE_PASSPORT_PHOTOGRAPH_FOR_BO_ONBOARDING || false;
            this.ALLOW_BVN_FOR_KYC_LEVEL_1_BUSINESS_ONBOARDING = config.ALLOW_BVN_FOR_KYC_LEVEL_1_BUSINESS_ONBOARDING || false;
            this.VALIDATE_BO_WCL_KYC = config.VALIDATE_BO_WCL_KYC || false;
            this.USE_GOOGLE_MAP_JAVASCRIPT_API = config.USE_GOOGLE_MAP_JAVASCRIPT_API || false;
            this.GEOLOCATION_THRESHOLD_IN_METER = config.GEOLOCATION_THRESHOLD_IN_METER || false;
            this.USE_ADDRESS_REVALIDATION = config.USE_ADDRESS_REVALIDATION || false;
            this.SHOW_TERMINAL_QUOTA_UPDATE = config.SHOW_TERMINAL_QUOTA_UPDATE || false;
            this.USE_PEP_NATIONALITY_INCOME_LEVEL_1_FLOW = config.USE_PEP_NATIONALITY_INCOME_LEVEL_1_FLOW || false;
            this.USE_BRM_PEP_NATIONALITY_INCOME_LEVEL_1_FLOW = config.USE_BRM_PEP_NATIONALITY_INCOME_LEVEL_1_FLOW || false;
            this.SHOW_BRM_LGA_UPDATE_ON_FVS_VIEW = config.SHOW_BRM_LGA_UPDATE_ON_FVS_VIEW || false;
            this.SHOW_FVS_ADDRESS_VERIFICATION_ROUTES = config.SHOW_FVS_ADDRESS_VERIFICATION_ROUTES || false;
            AppConfig.SHOW_FVS_ADDRESS_VERIFICATION_MENU = config.SHOW_FVS_ADDRESS_VERIFICATION_MENU || false;
            AppConfig.FVS_ADDRESS_VERIFICATION_TABS_TO_HIDE = config.FVS_ADDRESS_VERIFICATION_TABS_TO_HIDE || '';
            this.SC_PERFORMANCE_START_PERIOD = config.SC_PERFORMANCE_START_PERIOD || '04-2024';
            this.SHOW_FVS_PENDING_COUNT_BANNER_ON_BRM_DASHBOARD = config.SHOW_FVS_PENDING_COUNT_BANNER_ON_BRM_DASHBOARD || false;
            this.FVS_SHOW_ADDRESS_VERIFICATION_WIDGET = config.FVS_SHOW_ADDRESS_VERIFICATION_WIDGET || false;
            this.FVS_LOGIN_ROUTE_WITH_QUERY_PARAM =
                config.FVS_LOGIN_ROUTE_WITH_QUERY_PARAM || 'https://fv.fo-ui.development.teamapt.com/login-with-moniepoint?token=';
            this.ALLOW_BRM_RE_UPDATE_LGA_ON_FVS = config.ALLOW_BRM_RE_UPDATE_LGA_ON_FVS || false;
            this.USE_NEW_COMPLIANCE_URLS = config.USE_NEW_COMPLIANCE_URLS || false;
            this.MINIMUM_ADDRESS_VERIFICATION_TIME_IN_DAYS = config.MINIMUM_ADDRESS_VERIFICATION_TIME_IN_DAYS || 7;
            this.COUNTRY_FLAGS_URL = config.COUNTRY_FLAGS_URL || 'https://cdn-prod.moniepoint.com/country-flags/';
            this.MAXIMUM_ADDRESS_VERIFICATION_TIME_IN_DAYS = config.MAXIMUM_ADDRESS_VERIFICATION_TIME_IN_DAYS || 14;
            this.SHOW_ADDRESS_VERIFICATION_POP_UP_EVERY_LOGIN = config.SHOW_ADDRESS_VERIFICATION_POP_UP_EVERY_LOGIN || false;
            this.USE_CAC_BUSINESS_AFFILIATE_FLOW = config.USE_CAC_BUSINESS_AFFILIATE_FLOW || false;
            this.SHOW_SWAP_UPDATE_FOR_SC_AND_BRM = config.SHOW_SWAP_UPDATE_FOR_SC_AND_BRM || false;
            this.METAMAP_SCRIPT_URL = config.METAMAP_SCRIPT_URL;
            this.FVS_SHOW_BRM_CAN_UPDATE_BO_ADDRESS = config.FVS_SHOW_BRM_CAN_UPDATE_BO_ADDRESS || false;
            this.USE_MOCK_PEP_ISSUES_DATA = config?.USE_MOCK_PEP_ISSUES_DATA;
            this.USE_KYC_CORRECTIONS_V2 = config.USE_KYC_CORRECTIONS_V2 || false;
            this.USE_PHYSICAL_ADDRESS_VERIFICATION_FOR_KYC = config.USE_PHYSICAL_ADDRESS_VERIFICATION_FOR_KYC || false;
            this.USE_PHYSICAL_ADDRESS_VERIFICATION_FOR_BRM_KYC = config.USE_PHYSICAL_ADDRESS_VERIFICATION_FOR_BRM_KYC || false;
            this.USE_REGISTERED_BUSINESS_PRIMER_LABEL = config.USE_REGISTERED_BUSINESS_PRIMER_LABEL || false;
            this.USE_REGISTERED_BUSINESS_ROUTE = config.USE_REGISTERED_BUSINESS_ROUTE || false;
            this.SHOW_NEW_FAULTY_FLOW = config.SHOW_NEW_FAULTY_FLOW || false;
            this.USE_LOOM_MFA_SDK = config.USE_LOOM_MFA_SDK || false;
            this.SHOW_TERMINAL_RETRIEVAL_UPDATE = config.SHOW_TERMINAL_RETRIEVAL_UPDATE || false;
            AppConfig.SHOW_MY_APPROVAL_REQUESTS = config.SHOW_MY_APPROVAL_REQUESTS || false;
            this.CAN_MAKE_STATE_LGA_OPTIONAL = config.CAN_MAKE_STATE_LGA_OPTIONAL || false;
            this.USE_DAILY_STATEMENT_DATE_RANGE = config.USE_DAILY_STATEMENT_DATE_RANGE || false;
            this.SHOW_GLOBAL_SWAP_UPDATE = config.SHOW_GLOBAL_SWAP_UPDATE || false;
            this.USE_STATEMENT_REPORT_URL = config.USE_STATEMENT_REPORT_URL || false;
            this.MONIEPOINT_STATEMENT = config.MONIEPOINT_STATEMENT || '';
            this.MONIEDESK_API_BASE_URL = config.MONIEDESK_API_BASE_URL ?? '';
            this.MONIEDESK_CRM_SERVICE = config.MONIEDESK_CRM_SERVICE ?? '';
            this.MONIEDESK_ENTITY = config.MONIEDESK_ENTITY ?? '';
            this.MINIMUM_MFA_SIGN_UP_ALERT_KYC_LEVEL = config.MINIMUM_MFA_SIGN_UP_ALERT_KYC_LEVEL || 0;
            this.MINIMUM_MFA_SIGN_UP_ALERT_TEXT = config.MINIMUM_MFA_SIGN_UP_ALERT_TEXT || '';
            this.USE_NEW_DAILY_LIMIT_FLOW = config.USE_NEW_DAILY_LIMIT_FLOW || false;
            this.ENFORCE_ADDRESS_VERIFICATION_NEW_DAILY_LIMIT_FLOW = config.ENFORCE_ADDRESS_VERIFICATION_NEW_DAILY_LIMIT_FLOW || false;
            this.ENFORCE_OPTION_ADDRESS_VERIFICATION_NEW_DAILY_LIMIT_FLOW = config.ENFORCE_OPTION_ADDRESS_VERIFICATION_NEW_DAILY_LIMIT_FLOW || false;
            this.OTP_RESEND_V2 = config.OTP_RESEND_V2 || false;
            this.USE_2FA_FLOW_USER_PIN_RESET = config.USE_2FA_FLOW_USER_PIN_RESET || false;
            this.USE_2FA_FLOW_FORGOT_PASSCODE = config.USE_2FA_FLOW_FORGOT_PASSCODE || false;
            this.USE_2FA_FLOW_FORGOT_PASSWORD = config.USE_2FA_FLOW_FORGOT_PASSWORD || false;
            this.USE_2FA_FLOW_PASSCODE_CHANGE = config.USE_2FA_FLOW_PASSCODE_CHANGE || false;
            this.USE_2FA_FLOW_PASSWORD_CHANGE = config.USE_2FA_FLOW_PASSWORD_CHANGE || false;
            this.SHOW_KYC_LVL1_BUSINESS_NAME_DESCRIPTION_SIZE = config.SHOW_KYC_LVL1_BUSINESS_NAME_DESCRIPTION_SIZE || false;
            this.USE_ONBOARDING_MODULE_LAZY_LOADER = config.USE_ONBOARDING_MODULE_LAZY_LOADER || false;
            this.USE_NEW_LOAN_FACILITATOR_INPUT = config.USE_NEW_LOAN_FACILITATOR_INPUT || false;
            this.SHOW_PND_AND_LIENS_BANNER = config.SHOW_PND_AND_LIENS_BANNER || false;
            this.SHOW_SC_RM_CASHOUT = config.SHOW_SC_RM_CASHOUT || false;
            this.SHOW_BRM_PRM_CASHOUT = config.SHOW_BRM_PRM_CASHOUT || false;
            AppConfig.SHOW_PRM_PERFORMANCE_TRACKER = config.SHOW_PRM_PERFORMANCE_TRACKER || false;
            AppConfig.ENABLE_SUB_BRM = config.ENABLE_SUB_BRM || false;
            AppConfig.SHOW_KIOSK_MARKETERS = config.SHOW_KIOSK_MARKETERS || false;
            AppConfig.SHOW_SC_PERFORMANCE_REPORTS = config.SHOW_SC_PERFORMANCE_REPORTS || false;
            AppConfig.SHOW_SPO_PERFORMANCE_TRACKER = config.SHOW_SPO_PERFORMANCE_TRACKER || false;
            AppConfig.SHOW_BUSINESS_REMAPPING = config.SHOW_BUSINESS_REMAPPING ?? false;
            AppConfig.SHOW_ACCOUNTS_MENU_FOR_CM = config.SHOW_ACCOUNTS_MENU_FOR_CM ?? false;
            AppConfig.SHOW_WELFARE_ACCOUNT_FOR_BRM = config.SHOW_WELFARE_ACCOUNT_FOR_BRM ?? false;
            AppConfig.SHOW_WELFARE_ACCOUNT_FOR_SC = config.SHOW_WELFARE_ACCOUNT_FOR_SC ?? false;
            AppConfig.SHOW_WELFARE_ACCOUNT_FOR_RM = config.SHOW_WELFARE_ACCOUNT_FOR_RM ?? false;
            this.SHOW_BRM_ONBOARDING_NEXT_OF_KIN = config.SHOW_BRM_ONBOARDING_NEXT_OF_KIN ?? false;
            this.SHOW_BRM_BUSINESS_RECATEGORIZATION_NOTIFICATION = config.SHOW_BRM_BUSINESS_RECATEGORIZATION_NOTIFICATION ?? false;
            this.BUSINESSES_RM_AGENTS_TABLE_PAGE_SIZE = config.BUSINESSES_RM_AGENTS_TABLE_PAGE_SIZE ?? 10;
            this.BUSINESSES_AGENTS_TABLE_PAGE_SIZE = config.BUSINESSES_AGENTS_TABLE_PAGE_SIZE ?? 10;
            this.SHOW_BRM_ONBOARDING_CLUSTER_NAME = config.SHOW_BRM_ONBOARDING_CLUSTER_NAME ?? false;
            this.PARTNER_ONBOARDING_MIGRATION = config.PARTNER_ONBOARDING_MIGRATION || false;
            this.USE_ANALYTICS_TRACKING_SERVICE_IN_LOANS = config.USE_ANALYTICS_TRACKING_SERVICE_IN_LOANS || false;
            this.CUSTOMER_IO_WRITE_KEY = config.CUSTOMER_IO_WRITE_KEY || '';
            AppConfig.SHOW_MONIECRM = config.SHOW_MONIECRM || false;
            AppConfig.SHOW_TICKET_MANAGER = config.SHOW_TICKET_MANAGER || false;
            this.SHOW_REPAIR_CODE_UPDATE = config.SHOW_REPAIR_CODE_UPDATE || false;
            this.SHOW_CUSTOM_TRANSACTION_FIELD_CONFIG = config.SHOW_CUSTOM_TRANSACTION_FIELD_CONFIG || false;
            this.MONIEPOINT_POS = config.MONIEPOINT_POS || '';
            this.SHOW_PROFILE_EMAIL_UPDATE_BUTTON = config.SHOW_PROFILE_EMAIL_UPDATE_BUTTON ?? true;
            this.SHOW_PROFILE_PHONE_NUMBER_UPDATE_BUTTON = config.SHOW_PROFILE_PHONE_NUMBER_UPDATE_BUTTON ?? true;
            this.SHOW_PROFILE_DOB_UPDATE_BUTTON = config.SHOW_PROFILE_DOB_UPDATE_BUTTON ?? true;
            this.SHOW_PROFILE_IMAGE_UPDATE_BUTTON = config.SHOW_PROFILE_IMAGE_UPDATE_BUTTON ?? true;
            this.CUSTOMER_IO_CDN_URL = config.CUSTOMER_IO_CDN_URL || '';
            this.SHOW_MONIEBOOK_ONBOARDING_ON_BO_DETAILS = config.SHOW_MONIEBOOK_ONBOARDING_ON_BO_DETAILS || false;
            this.MONIEBOOK_SERVICE_URL = config.MONIEBOOK_SERVICE_URL || '';
            this.MONIEBOOK_DASHBOARD_URL = config.MONIEBOOK_DASHBOARD_URL ?? false;
            this.SHOW_MONIEBOOK_AUTO_ONBOARD_BANNER = config.SHOW_MONIEBOOK_AUTO_ONBOARD_BANNER ?? false;
            AppConfig.MONIEBOOK_FEATURE_SHOW_REFERRALS = config.MONIEBOOK_FEATURE_SHOW_REFERRALS || false;
            this.REMOVE_TC_DOCUMENT_FOR_BRM = config.REMOVE_TC_DOCUMENT_FOR_BRM || false;
            this.SHOW_PERFORMANCE_TRACKER_COMMISSION_HISTORY = config.SHOW_PERFORMANCE_TRACKER_COMMISSION_HISTORY || false;
            this.USE_OTP_WHATSAPP_DEVICE_REGISTRATION = config.USE_OTP_WHATSAPP_DEVICE_REGISTRATION || false;
            this.USE_OTP_WHATSAPP_FORGOT_PASSCODE = config.USE_OTP_WHATSAPP_FORGOT_PASSCODE || false;
            this.USE_OTP_WHATSAPP_FORGOT_PASSWORD = config.USE_OTP_WHATSAPP_FORGOT_PASSWORD || false;
            this.USE_OTP_WHATSAPP_PASSCODE_CHANGE = config.USE_OTP_WHATSAPP_PASSCODE_CHANGE || false;
            this.USE_OTP_WHATSAPP_PASSWORD_CHANGE = config.USE_OTP_WHATSAPP_PASSWORD_CHANGE || false;
            this.USE_OTP_WHATSAPP_RESET_USER_PIN = config.USE_OTP_WHATSAPP_RESET_USER_PIN || false;
            this.SEND_SMS_OTP_2FA = config.SEND_SMS_OTP_2FA || false;
            this.USE_NEW_OTP_DESIGN_DEVICE_REGISTRATION = config.USE_NEW_OTP_DESIGN_DEVICE_REGISTRATION ?? true;
            this.WHATSPP_OTP_COUNTDOWN_IN_SECONDS = config.WHATSPP_OTP_COUNTDOWN_IN_SECONDS || 60;
            this.SHOW_TERMINAL_ASSIGNMENT_TO_BACKOFFICE_UPDATE = config.SHOW_TERMINAL_ASSIGNMENT_TO_BACKOFFICE_UPDATE || false;
            this.SHOW_UPDATE_TERMINAL_STATUS_ACTION = config.SHOW_UPDATE_TERMINAL_STATUS_ACTION || false;
            this.SHOW_PROFILE_ADDRESS_UPDATE_BUTTON_KYC_LEVEL = config.SHOW_PROFILE_ADDRESS_UPDATE_BUTTON_KYC_LEVEL ?? 0;
            AppConfig.CARDS_USE_BRM_AUTHORITIES = config.CARDS_USE_BRM_AUTHORITIES || false;
            AppConfig.USE_PROVISIONAL_OFFER_GENERATION_FLOW = config.USE_PROVISIONAL_OFFER_GENERATION_FLOW || false;
            this.SHOW_LIENS_ON_ACCOUNTS_PAGE = config.SHOW_LIENS_ON_ACCOUNTS_PAGE || false;
            this.CARDS_USE_NEW_ASSIGNMENT_API = config.CARDS_USE_NEW_ASSIGNMENT_API || false;
            this.USE_NEW_TRANSFER_SUMMARY = config?.USE_NEW_TRANSFER_SUMMARY || false;
            this.MONIECRM_URL = config.MONIECRM_URL || '';
            this.ADDRESS_VERIFICATION_MFE_URL = config.ADDRESS_VERIFICATION_MFE_URL || '';
            this.TICKET_MANAGER_URL = config.TICKET_MANAGER_URL || '';
            this.MONIEPOINT_PAYMENT_URL = config.MONIEPOINT_PAYMENT_URL || '';
            this.SHOW_BRM_TERMINAL_TRANSACTION_SUMMARY = config.SHOW_BRM_TERMINAL_TRANSACTION_SUMMARY ?? false;
            this.SHOW_BRM_CARD_SALES_PERFORMANCE_UPDATE = config.SHOW_BRM_CARD_SALES_PERFORMANCE_UPDATE ?? false;
            this.SHOW_WITHHOLDING_TAX = config.SHOW_WITHHOLDING_TAX || false;
            this.SHOW_CASHOUT_FEE = config.SHOW_CASHOUT_FEE || false;
            this.HIDE_SIDEMENU_ON_MOBILE_APP = config.HIDE_SIDEMENU_ON_MOBILE_APP || false;
            AppConfig.SHOW_CM_MENU_FOR_SC = config.SHOW_CM_MENU_FOR_SC || false;
            AppConfig.SHOW_CLUSTERS_MENU_FOR_SC = config.SHOW_CLUSTERS_MENU_FOR_SC || false;
            AppConfig.SHOW_CM_MENU_FOR_RM = config.SHOW_CM_MENU_FOR_RM || false;
            AppConfig.SHOW_SC_MENU_FOR_RM = config.SHOW_SC_MENU_FOR_RM || false;
            AppConfig.SHOW_BRM_APPROVALS_MENU_FOR_CM = config.SHOW_BRM_APPROVALS_MENU_FOR_CM || false;
            AppConfig.SHOW_LIMIT_APPROVAL_MENU_FOR_CM = config.SHOW_LIMIT_APPROVAL_MENU_FOR_CM || false;
            AppConfig.SHOW_MY_COURSES_MENU_FOR_CM = config.SHOW_MY_COURSES_MENU_FOR_CM || false;
            AppConfig.SHOW_PERFORMANCE_TRACKER_MENU_FOR_CM = config.SHOW_PERFORMANCE_TRACKER_MENU_FOR_CM || false;
            AppConfig.SHOW_ACCOUNTS_MENU_FOR_CM = config.SHOW_ACCOUNTS_MENU_FOR_CM || false;
            AppConfig.SHOW_PERFORMANCE_REPORTS_FOR_CM = config.SHOW_PERFORMANCE_REPORTS_FOR_CM || false;
            this.DISABLE_AUTO_LOGOUT_ON_MOBILE_APP = config.DISABLE_AUTO_LOGOUT_ON_MOBILE_APP || false;
            this.SHOW_PROVISIONAL_OFFERS_CONTACT_US = config?.SHOW_PROVISIONAL_OFFERS_CONTACT_US || false;
            this.SHOW_PROVISIONAL_OFFERS_LIST = config?.SHOW_PROVISIONAL_OFFERS_LIST || false;
            this.CARDS_DELIVERY_USE_CARD_SERVICE = config.CARDS_DELIVERY_USE_CARD_SERVICE || false;
            this.SHOW_POS_WEB_HOOK = config.SHOW_POS_WEB_HOOK || false;
            this.SHOULD_USE_KYC_LVL2_UPGRADE_FLOW = config.SHOULD_USE_KYC_LVL2_UPGRADE_FLOW || false;
            this.SHOW_BRM_PENDING_LIST = config.SHOW_BRM_PENDING_LIST || false;
            this.ENABLE_MARKETER_ONBOARDING = config.ENABLE_MARKETER_ONBOARDING || false;
            this.SHOW_PROVISIONAL_OFFER_LOAN_TENURE = config?.SHOW_PROVISIONAL_OFFER_LOAN_TENURE || false;
            this.SHOW_PROVISIONAL_OFFER_REPAYMENT_FREQUENCY = config?.SHOW_PROVISIONAL_OFFER_REPAYMENT_FREQUENCY || false;
            this.USE_KYC_BVN_NATIONALITY = config.USE_KYC_BVN_NATIONALITY || false;
            this.USE_BRM_KYC_BVN_NATIONALITY = config.USE_BRM_KYC_BVN_NATIONALITY || false;
            this.SHOW_PROFILE_NAME_UPDATE_BUTTON = config.SHOW_PROFILE_NAME_UPDATE_BUTTON ?? false;
            this.SHOW_PROFILE_DOB_NEW_UPDATE_BUTTON = config.SHOW_PROFILE_DOB_NEW_UPDATE_BUTTON ?? false;
            this.SHOW_PROFILE_DOB_NEW_UPDATE_SECTION = config.SHOW_PROFILE_DOB_NEW_UPDATE_SECTION ?? false;
            this.ENABLE_PROFILE_UPDATE_BUTTON_KYC_LEVEL = config.ENABLE_PROFILE_UPDATE_BUTTON_KYC_LEVEL ?? 0;
            this.SHOW_KFS_PROVISIONAL_OFFER = config.SHOW_KFS_PROVISIONAL_OFFER || false;
            this.SHOW_REPAYMENT_PLAN_PROVISIONAL_OFFER = config.SHOW_REPAYMENT_PLAN_PROVISIONAL_OFFER || false;
            this.SHOW_POS_INSURED_FLOW_V2 = config.SHOW_POS_INSURED_FLOW_V2 || false;
            this.SHOW_BRM_INSURE_TERMINAL_FLOW = config.SHOW_BRM_INSURE_TERMINAL_FLOW || false;
            this.SHOW_INSURANCE_INFO = config.SHOW_INSURANCE_INFO || false;
            this.SHOW_CARD_DISTRIBUTION_EFFICIENCY_NEW_UI = config.SHOW_CARD_DISTRIBUTION_EFFICIENCY_NEW_UI || false;
            this.SHOW_RETRIVE_BUTTON_CARD_DISTRIBUTION_EFFICIENCY_NEW_UI = config.SHOW_RETRIVE_BUTTON_CARD_DISTRIBUTION_EFFICIENCY_NEW_UI || false;
            this.HIDE_BO_KYC_LVL1_BACK_BUTTON = config.HIDE_BO_KYC_LVL1_BACK_BUTTON || false;
            this.SHOW_INSURANCE_INFO_KFS = config.SHOW_INSURANCE_INFO_KFS || false;
            AppConfig.SHOW_REMOTE_GROWTH_MODULE = config.SHOW_REMOTE_GROWTH_MODULE || false;
            AppConfig.SHOW_REMOTE_ADDRESS_VERIFICATION_MODULE = config.SHOW_REMOTE_ADDRESS_VERIFICATION_MODULE || false;
            this.SHOW_DEVICES_MFE = config.SHOW_DEVICES_MFE || false;
            this.SHOW_NOTIFICATION_PREFERENCE_MFE = config.SHOW_NOTIFICATION_PREFERENCE_MFE || false;
            this.SHOW_CONSENT_MANAGEMENT_MFE = config.SHOW_CONSENT_MANAGEMENT_MFE || false;
            this.SHOW_BUSINESS_TYPE_MFE = config.SHOW_BUSINESS_TYPE_MFE || false;
            this.SHOW_LANGUAGE_MFE = config.SHOW_LANGUAGE_MFE || false;
            this.SHOW_OTHERS_MFE = config.SHOW_OTHERS_MFE || false;
            this.SHOW_TRANSFER_CONFIGURATION_MFE = config.SHOW_TRANSFER_CONFIGURATION_MFE || false;
            this.SETTINGS_MFE_URL = config.SETTINGS_MFE_URL || '';
            this.PROFILE_SETUP_MFE_URL = config.PROFILE_SETUP_MFE_URL || '';
            this.SHOW_PROFILE_SETUP_MFE = config.SHOW_PROFILE_SETUP_MFE || false;
            this.LOANS_DASHBOARD_WIDGET_URL = config.LOANS_DASHBOARD_WIDGET_URL || '';
            this.LOANS_HOST_URL = config.LOANS_HOST_URL || '';
            this.LOANS_MARKUP_URL = config.LOANS_MARKUP_URL || '';
            this.LOANS_WCL_URL = config.LOANS_WCL_URL || '';
            this.LOANS_OVD_URL = config.LOANS_OVD_URL || '';
            this.LOANS_ASSETS_URL = config.LOANS_ASSETS_URL || '';
            this.LOANS_LOCALES_URL = config.LOANS_LOCALES_URL || '';
            this.SHOW_LOANS_DASHBOARD_WIDGET = config.SHOW_LOANS_DASHBOARD_WIDGET || false;
            AppConfig.USE_NEW_LOAN_AGREEMENT_FLOW = config.USE_NEW_LOAN_AGREEMENT_FLOW || false;
            AppConfig.USE_NEW_LOAN_APP = config.USE_NEW_LOAN_APP || false;
            this.USE_NEW_PRIMARY_ACCOUNT_FLAG_ON_DISBURSEMENT_ACCOUNTS_ENDPOINT =
                config.USE_NEW_PRIMARY_ACCOUNT_FLAG_ON_DISBURSEMENT_ACCOUNTS_ENDPOINT || false;
            this.USE_NEW_RENEWAL_SUBMISSION_ENDPOINT = config.USE_NEW_RENEWAL_SUBMISSION_ENDPOINT || false;
            this.USE_FIRST_LOAN_DISBURSAL_ACCOUNT = config.USE_FIRST_LOAN_DISBURSAL_ACCOUNT || false;
            this.TRANSFER_VALIDATION_FAILURE_MODAL_TITLE = config.TRANSFER_VALIDATION_FAILURE_MODAL_TITLE || '';
            this.SHOW_SAYT_V2 = config.SHOW_SAYT_V2 || false;
            this.GROWTH_URL = config.GROWTH_URL || '';
            this.GROWTH_V2_URL = config.GROWTH_V2_URL || '';
            this.USE_MONIEPOINT_MFB_LOGO = config.USE_MONIEPOINT_MFB_LOGO || false;
            this.SHOW_LICENSED_AND_SECURED_INFO = config.SHOW_LICENSED_AND_SECURED_INFO || false;
            this.SHOW_BRM_ONBOARDING_PROOF_OF_ADDRESS = config.SHOW_BRM_ONBOARDING_PROOF_OF_ADDRESS || false;
            this.ALWAYS_SHOW_CM_INFO = config.ALWAYS_SHOW_CM_INFO || false;
            this.SHOW_TERMINAL_ASSIGNMENT_TO_BACKOFFICE_CLEANUP = config.SHOW_TERMINAL_ASSIGNMENT_TO_BACKOFFICE_CLEANUP ?? false;
            this.SHOW_TERMS_AND_CONDITION_CHECKBOX = config.SHOW_TERMS_AND_CONDITION_CHECKBOX || false;
            this.SHOW_STAFF_PROFILE_UPDATE_BUTTON = config.SHOW_STAFF_PROFILE_UPDATE_BUTTON || false;
            this.SHOW_BRM_ONBOARDING_IDENTIFICATION = config.SHOW_BRM_ONBOARDING_IDENTIFICATION || false;
            this.ENABLE_LOGIN_LOCATION_HEADERS = config.ENABLE_LOGIN_LOCATION_HEADERS || false;
            this.ENABLE_MANDATORY_LOGIN_LOCATION_ACCESS = config.ENABLE_MANDATORY_LOGIN_LOCATION_ACCESS || false;
            this.SHOW_LOAN_REQUEST_FLOW_TENURE = config.SHOW_LOAN_REQUEST_FLOW_TENURE || false;
            this.SHOW_LOAN_REQUEST_FLOW_REPAYMENT_FREQUENCY = config.SHOW_LOAN_REQUEST_FLOW_REPAYMENT_FREQUENCY || false;
            this.SHOW_BUSINESS_BULK_INSURANCE_UPDATE = config.SHOW_BUSINESS_BULK_INSURANCE_UPDATE ?? false;
            this.USE_NEW_BO_KYC_LEVEL3_V3_FLOW = config.USE_NEW_BO_KYC_LEVEL3_V3_FLOW || false;
            this.OKHI_API_KEY = config.OKHI_API_KEY || '01J9VPGCXJJRDCR4BVBQB50VHK';
            this.OKHI_BRANCH_ID = config.OKHI_BRANCH_ID || '67080a4de25a4d900b33a17f';
            this.SHOW_FACE_VERIFICATION_IN_KYC_LVL3 = config.SHOW_FACE_VERIFICATION_IN_KYC_LVL3 || false;
            this.MONIEPOINT_SAVINGS_V2_URL = config.MONIEPOINT_SAVINGS_V2_URL || 'https://mab-loans-savings.development.moniepoint.com';
            this.SHOW_DISBURSEMENT_ACCOUNT_CONFIRMATION_MODAL = config.SHOW_DISBURSEMENT_ACCOUNT_CONFIRMATION_MODAL || false;
            this.S_CODE1 = config.S_CODE1 ?? '';
            this.S_CODE2 = config.S_CODE2 ?? '';
            this.SHOW_OVERDRAFT_MANUAL_REPAYMENT = config.SHOW_OVERDRAFT_MANUAL_REPAYMENT || false;
            this.GET_BRM_APPROVALS_PENDING_CLAIM_REQUESTS_FOR_CM = config.GET_BRM_APPROVALS_PENDING_CLAIM_REQUESTS_FOR_CM || false;
            this.GET_BRM_APPROVALS_PROCESSING_CLAIM_REQUESTS_FOR_CM = config.GET_BRM_APPROVALS_PROCESSING_CLAIM_REQUESTS_FOR_CM || false;
            this.GET_BRM_APPROVALS_TREATED_CLAIM_REQUESTS_FOR_CM = config.GET_BRM_APPROVALS_TREATED_CLAIM_REQUESTS_FOR_CM || false;
            this.SHOW_BRM_APPROVALS_ACTION_COLUMN_FOR_CM = config.SHOW_BRM_APPROVALS_ACTION_COLUMN_FOR_CM || false;
            this.SHOW_BUSINESS_CATEGORY_UPDATE = config.SHOW_BUSINESS_CATEGORY_UPDATE ?? false;
            this.UPDATE_BUSINESS_CATEGORY_URL = config.UPDATE_BUSINESS_CATEGORY_URL ?? '';
            this.USE_ADDITIONAL_BUSINESS_KYC_LEVEL1 = config.USE_ADDITIONAL_BUSINESS_KYC_LEVEL1 || false;
            this.BRM_USE_ADDITIONAL_BUSINESS_KYC_LEVEL1 = config.BRM_USE_ADDITIONAL_BUSINESS_KYC_LEVEL1 || false;
            this.USE_MULTIPLE_BUSINESS_TYPES = config.USE_MULTIPLE_BUSINESS_TYPES || false;
            this.SHOW_BRM_BUSINESS_TYPES = config.SHOW_BRM_BUSINESS_TYPES || false;
            this.STORE_FRONT_IMAGE_MAX_SIZE = config.STORE_FRONT_IMAGE_MAX_SIZE || 0;
            this.MAX_ALLOWED_BUSINESS_TYPES = config.MAX_ALLOWED_BUSINESS_TYPES || 0;
            this.ENFORCE_LOCATION_DURING_PAYMENT = config.ENFORCE_LOCATION_DURING_PAYMENT || false;
            this.ENABLE_LOCATION_DURING_PAYMENT = config.ENABLE_LOCATION_DURING_PAYMENT || false;
            this.ACCOUNT_UPGRADE_MFE_URL = config.ACCOUNT_UPGRADE_MFE_URL ?? '';
            this.SHOW_ACCOUNT_UPGRADE_MFE = config.SHOW_ACCOUNT_UPGRADE_MFE ?? false;
            AppConfig.SHOW_PARTNER_UPGRADE_MFE = config.SHOW_PARTNER_UPGRADE_MFE ?? false;
            this.USE_UPDATED_KYC_LIMITS_FLOW = config.USE_UPDATED_KYC_LIMITS_FLOW ?? true;
            this.USE_NEW_TERMINALS_ENDPOINT = config.USE_NEW_TERMINALS_ENDPOINT ?? false;
            this.SHOW_POS_TC = config.SHOW_POS_TC ?? false;
            this.ENABLE_ONBOARDING_LOCATION_HEADERS = config.ENABLE_ONBOARDING_LOCATION_HEADERS ?? false;
            this.USE_POLICY_DOCUMENTS_API = config?.USE_POLICY_DOCUMENTS_API || false;
            this.USE_FACETEC_LIVELINESS = config.USE_FACETEC_LIVELINESS || false;
            this.USE_BRM_FACETEC_LIVELINESS = config.USE_BRM_FACETEC_LIVELINESS || false;
            this.LIVELINESS_SERVICE_URL = config?.LIVELINESS_SERVICE_URL ?? '';
            this.MFE_CDN_IDENTITY_VERIFICATION_URL = config?.MFE_CDN_IDENTITY_VERIFICATION_URL ?? '';
            this.ENABLE_ACCOUNTS_WALLET_TRANSACTIONS_FOR_CM = config.ENABLE_ACCOUNTS_WALLET_TRANSACTIONS_FOR_CM || false;
            this.ENABLE_ACCOUNTS_HISTORICAL_TRANSACTIONS_FOR_CM = config.ENABLE_ACCOUNTS_HISTORICAL_TRANSACTIONS_FOR_CM || false;
            this.ENABLE_ACCOUNTS_CASHOUT_FOR_CM = config.ENABLE_ACCOUNTS_CASHOUT_FOR_CM || false;
            AppConfig.SHOW_TC_COMPLIANCE_DASHBOARD = config.SHOW_TC_COMPLIANCE_DASHBOARD ?? false;
            this.REMOVE_REFRESH_TOKEN_FOR_CM = config.REMOVE_REFRESH_TOKEN_FOR_CM ?? false;
            this.REMOVE_CHECK_AUTH_FOR_CM = config.REMOVE_CHECK_AUTH_FOR_CM ?? false;
            this.USE_BRM_CREATE_BO_BUSINESS_PAGE = config.USE_BRM_CREATE_BO_BUSINESS_PAGE ?? false;
            this.HIDE_BRM_PRM_SELF_ONBOARDING_ADDRESS_VERIFICATION = config.HIDE_BRM_PRM_SELF_ONBOARDING_ADDRESS_VERIFICATION ?? false;
            this.USE_NEW_BUSINESS_TYPES_UI = config.USE_NEW_BUSINESS_TYPES_UI || false;
            this.MARKETER_ONBOARDING_MFE_URL = config?.MARKETER_ONBOARDING_MFE_URL ?? '';
            AppConfig.SHOW_MARKETER_ONBOARDING_MFE = config?.SHOW_MARKETER_ONBOARDING_MFE ?? false;
            this.SHOW_POS_TERMINAL_CONDITION_DETAIL_FOR_SC = config?.SHOW_POS_TERMINAL_CONDITION_DETAIL_FOR_SC ?? false;
            this.MONIEPOINT_CONSENT_MANAGEMENT_URL = config.MONIEPOINT_CONSENT_MANAGEMENT_URL ?? '';
            this.SHOW_PENDING_CONSENT_BANNER = config.SHOW_PENDING_CONSENT_BANNER ?? false;
            this.SHOW_TERMINAL_SWAP_V4_UPDATE = config.SHOW_TERMINAL_SWAP_V4_UPDATE ?? false;
            this.USE_KYC_LVL_1_PREVENT_HYBRID_MERCHANT = config.USE_KYC_LVL_1_PREVENT_HYBRID_MERCHANT ?? false;
            this.USE_BRM_KYC_LVL_1_PREVENT_HYBRID_MERCHANT = config.USE_BRM_KYC_LVL_1_PREVENT_HYBRID_MERCHANT ?? false;
            this.USE_SOFT_ONBOARDING_PREVENT_HYBRID_MERCHANT = config.USE_SOFT_ONBOARDING_PREVENT_HYBRID_MERCHANT ?? false;
            this.SHOW_SWAP_HISTORY = config.SHOW_SWAP_HISTORY ?? false;
            this.SHOW_QUOTA_FOR_NEW_TERMINALS_UPDATE = config.SHOW_QUOTA_FOR_NEW_TERMINALS_UPDATE ?? false;
            this.ENABLE_BRM_PRM_REQUEST_UPDATION = config.ENABLE_BRM_PRM_REQUEST_UPDATION ?? false;
            this.USE_UPDATED_CLUSTER_ASSIGNMENT_URL = config.USE_UPDATED_CLUSTER_ASSIGNMENT_URL ?? false;
            this.ALLOW_SEARCH_BRM_CLUSTER_ASSIGNMENT = config.ALLOW_SEARCH_BRM_CLUSTER_ASSIGNMENT ?? false;
            AppConfig.USE_MFE_SC_TERMINAL_REQUESTS = config.USE_MFE_SC_TERMINAL_REQUESTS ?? false;
            this.SHOW_INVENTORY_STATUS_FILTER = config.SHOW_INVENTORY_STATUS_FILTER ?? false;
        });
    }

    private setConfiguration(response: any): void {
        this.USE_UNIFIED_PROVISIONAL_OFFER_FLOW = (response && response.USE_UNIFIED_PROVISIONAL_OFFER_FLOW) || false;
        this.mock = (response && response.mock) || false;
        AppConfig.CLIENT_VERSION = response?.CLIENT_VERSION || '0.0.0';
        this.MONIEPOINT_HOST = (response && response.MONIEPOINT_HOST) || 'http://localhost:4200/';
        this.MONIEPOINT_POS_ERP_INTEGRATION = (response && response.MONIEPOINT_POS_ERP_INTEGRATION) || '';
        this.MONIEBOOK_ENV_URL = (response && response.MONIEBOOK_ENV_URL) || 'http://localhost:4200/';
        this.ASSETS_HOST = (response && response.ASSETS_HOST) || 'http://localhost:4200/';
        this.MONIEPOINT_SAVINGS = (response && response.MONIEPOINT_SAVINGS) || '';
        this.MONIEPOINT_LOANS = (response && response.MONIEPOINT_LOANS) || '';
        this.MONIEPOINT_USER_URL = (response && response.MONIEPOINT_USER_URL) || '';
        this.MONIEPOINT_WORKFLOW_URL = (response && response.MONIEPOINT_WORKFLOW_URL) || '';
        this.WLC_MANAGEMENT = (response && response.WLC_MANAGEMENT) || '';
        this.LOAN_GATEWAY_SERVICE_URL = (response && response.LOAN_GATEWAY_SERVICE_URL) || '';
        this.WCL_PORTFOLIO_MANAGEMENT = (response && response.WCL_PORTFOLIO_MANAGEMENT) || '';
        this.LMS_SERVICE_URL = response?.LMS_SERVICE_URL ?? '';
        this.MARKUP_SERVICE_URL = response?.MARKUP_SERVICE_URL ?? '';
        this.WCL_SERVICE_URL_V2 = response?.WCL_SERVICE_URL_V2 ?? '';
        this.OVD_SERVICE_URL_V2 = response?.OVD_SERVICE_URL_V2 ?? '';
        this.ENABLE_WCL_COMBINED_GUARANTOR_SUBMISSION = (response && response.ENABLE_WCL_COMBINED_GUARANTOR_SUBMISSION) || false;
        this.ENABLE_WCL_PLATFORM_HTTP_HEADER = (response && response.ENABLE_WCL_PLATFORM_HTTP_HEADER) || false;
        this.USE_WCL_BUSINESS_OWNER_REPAYMENT_ACCOUNTS = response?.USE_WCL_BUSINESS_OWNER_REPAYMENT_ACCOUNTS || false;
        this.USE_WCL_BUSINESS_OWNER_DISBURSEMENT_ACCOUNTS = response?.USE_WCL_BUSINESS_OWNER_DISBURSEMENT_ACCOUNTS || false;
        this.USE_WCL_BUSINESS_ADDRESS_VERIFICATION_V2 = response?.USE_WCL_BUSINESS_ADDRESS_VERIFICATION_V2 || false;
        this.ENABLE_WCL_GEOLOCATION_HIGH_ACCURACY = response?.ENABLE_WCL_GEOLOCATION_HIGH_ACCURACY || false;
        AppConfig.SHOW_WCL_IN_BUSINESS_USER_DASHBOARD = (response && response.SHOW_WCL_IN_BUSINESS_USER_DASHBOARD) || false;
        AppConfig.SHOW_OVERDRAFT_RUNNING_LOANS_V2 = (response && response.SHOW_OVERDRAFT_RUNNING_LOANS_V2) || false;
        this.SHOW_OVERDRAFT_RUNNING_LOANS_V2_SALES_VALUE = (response && response.SHOW_OVERDRAFT_RUNNING_LOANS_V2_SALES_VALUE) || false;
        this.SHOW_LOAN_PRODUCT_SELECTION_FLOW = (response && response.SHOW_LOAN_PRODUCT_SELECTION_FLOW) || false;
        this.USE_OVD_NEW_AGREEMENT_FLOW = (response && response.USE_OVD_NEW_AGREEMENT_FLOW) || false;
        this.SHOW_OVERDRAFT_RUNNING_LOANS_V2_LEARN_ABOUT_OVERDRAFT =
            (response && response.SHOW_OVERDRAFT_RUNNING_LOANS_V2_LEARN_ABOUT_OVERDRAFT) || false;
        this.SHOW_OVERDRAFT_RUNNING_LOANS_V2_DEACTIVATE_OVERDRAFT =
            (response && response.SHOW_OVERDRAFT_RUNNING_LOANS_V2_DEACTIVATE_OVERDRAFT) || false;
        AppConfig.SHOW_WCL_BUSINESS_USER_DASHBOARD_NEW_BADGE = (response && response.SHOW_WCL_BUSINESS_USER_DASHBOARD_NEW_BADGE) || false;
        AppConfig.SHOW_PERFORMANCE_TRACKER_FOR_RM_SC = (response && response.SHOW_PERFORMANCE_TRACKER_FOR_RM_SC) || false;
        this.MONIEPOINT_CARDS = (response && response.MONIEPOINT_CARDS) || '';
        this.MONIEPOINT_INSURANCE = (response && response.MONIEPOINT_INSURANCE) || '';
        this.MONIEPOINT_ACCOUNTING = (response && response.MONIEPOINT_ACCOUNTING) || '';
        this.MONIEPOINT_ACCOUNTING_STAGING = (response && response.MONIEPOINT_ACCOUNTING_STAGING) || '';
        this.MONIEPOINT_ACCOUNTS = (response && response.MONIEPOINT_ACCOUNTS) || '';
        this.MONIEPOINT_FV_CORE = (response && response.MONIEPOINT_FV_CORE) || '';
        this.MONIEPOINT_WITHDRAWAL = (response && response.MONIEPOINT_WITHDRAWAL) || '';
        this.MONIEPOINT_DEPOSIT = (response && response.MONIEPOINT_DEPOSIT) || '';
        this.MONIEPOINT_OFFLINE_SALES_URL = (response && response.MONIEPOINT_OFFLINE_SALES_URL) || '';
        this.MONIEPOINT_TERMINAL_INVENTORY = response?.MONIEPOINT_TERMINAL_INVENTORY ?? '';
        this.MONIEPOINT_AREA = (response && response.MONIEPOINT_AREA) || '';
        this.MONIEPOINT_LOGISTICS = (response && response.MONIEPOINT_LOGISTICS) || '';
        this.MONIEPOINT_REPORT = (response && response.MONIEPOINT_REPORT) || '';
        this.MONIEPOINT_BILL_PAYMENT = (response && response.MONIEPOINT_BILL_PAYMENT) || '';
        this.MONIEPOINT_MFA_LOOM = (response && response.MONIEPOINT_MFA_LOOM) || '';
        this.MONIEPOINT_GAMIFICATION = (response && response.MONIEPOINT_GAMIFICATION) || '';
        this.MONIEPOINT_REFERRALS_CASHOUT_SERVICE = (response && response.MONIEPOINT_REFERRALS_CASHOUT_SERVICE) || '';
        this.MONIEPOINT_DASHBOARD = (response && response.MONIEPOINT_DASHBOARD) || '';
        this.GRAFANA_URL = (response && response.GRAFANA_URL) || '';
        this.DOMAIN_ID = (response && response.domain) || 'MONIEPOINT';
        this.SHOW_MOBILE_WEB_VIEW = (response && response.SHOW_MOBILE_WEB_VIEW) || false;
        this.DEFAULT_OTP_COUNT_DOWN = (response && response.DEFAULT_OTP_COUNT_DOWN) || 600;
        this.REDIRECT_LOGIN_USER_TYPE = (response && response.REDIRECT_LOGIN_USER_TYPE) || 0;
        this.REDIRECT_ACCESS_TOKEN = (response && response.REDIRECT_ACCESS_TOKEN) || null;
        this.appTimeout = (response && response.APP_TIMEOUT) || 30000;
        this.clientId = response && response.CLIENT_ID;
        this.REDIRECT_URL = (response && response.REDIRECT_URL) || '/login';
        this.DOMAIN_ID = (response && response.DOMAIN_ID) || 'MONIEPOINT';
        this.allowAgentLogin = response && response.ALLOW_AGENT_LOGIN;
        this.KUWEGO_URL = (response && response.KUWEGO_URL) || '';
        this.KUWEGO_IMAGE_URL = (response && response.KUWEGO_IMAGE_URL) || '';
        this.KUWEGO_LOANS = (response && response.KUWEGO_LOANS) || '';
        this.FILE_SERVICE = (response && response.FILE_SERVICE) || '';
        this.FVS_FILE_SERVICE = (response && response.FVS_FILE_SERVICE) || '';
        this.SHOW_COMPLIANCE_VIEW = (response && response.SHOW_COMPLIANCE_VIEW) || false;
        this.ALLOW_POS_REQUEST = (response && response.ALLOW_POS_REQUEST) || false;
        this.SHOW_CONSOLIDATION_VIEW = (response && response.SHOW_CONSOLIDATION_VIEW) || false;
        this.ALLOW_SIGN_UP = (response && response.ALLOW_SIGN_UP) || false;
        this.MONIEPOINT_NOTIFICATION = (response && response.MONIEPOINT_NOTIFICATION) || '';
        this.SHOW_TRANSACTION_SHARE_BUTTON = (response && response.SHOW_TRANSACTION_SHARE_BUTTON) || false;
        this.SHOW_TRAINING_VIEW = (response && response.SHOW_TRAINING_VIEW) || false;
        this.MONIEPOINT_ONBOARDING = (response && response.MONIEPOINT_ONBOARDING) || '';
        this.MONIEPOINT_AVS = (response && response.MONIEPOINT_AVS) || '';
        this.MONIEPOINT_TERMINAL = (response && response.MONIEPOINT_TERMINAL) || '';
        this.SHOW_NEW_SETTING_VIEW = (response && response.SHOW_NEW_SETTING_VIEW) || false;
        this.SHOW_FEE_WAIVER = (response && response.SHOW_FEE_WAIVER) || false;
        this.SHOW_CAPITAL_LOANS_MENU = (response && response.SHOW_CAPITAL_LOANS_MENU) || false;
        this.SHOW_CAPITAL_LOANS_WEB = (response && response.SHOW_CAPITAL_LOANS_WEB) || false;
        this.SHOW_DOWNLOAD_POS_ACCOUNT_DETAILS = (response && response.SHOW_DOWNLOAD_POS_ACCOUNT_DETAILS) || false;
        this.ALLOW_KYC = (response && response.ALLOW_KYC) || false;
        this.SHOW_RE_ACT_LINK_ONBOARDING_BO = (response && response.SHOW_RE_ACT_LINK_ONBOARDING_BO) || false;
        this.META_MAP_FLOW_ID = (response && response.META_MAP_FLOW_ID) || '62ea31664733dc001d80f9ac';
        this.META_MAP_PERSONAL_INFO_FLOW_ID = (response && response.META_MAP_PERSONAL_INFO_FLOW_ID) || '636b748264ac5e001d8f6aac';
        this.META_MAP_LOW_LEVEL_ACCOUNT_FLOW_ID = (response && response.META_MAP_LOW_LEVEL_ACCOUNT_FLOW_ID) || '63bd31422afaa3001c941354';
        this.SHOW_KYC_REGISTERED_BUSINESS = (response && response.SHOW_KYC_REGISTERED_BUSINESS) || false;
        this.SHOW_POS_REQUEST_MENU = (response && response.SHOW_POS_REQUEST_MENU) || false;
        this.SHOW_CARDS_MENU = (response && response.SHOW_CARDS_MENU) || false;
        this.SHOW_SUPPORT = (response && response.SHOW_SUPPORT) || false;
        this.SHOW_CASHOUT_BUTTON = (response && response.SHOW_CASHOUT_BUTTON) || false;
        this.SHOW_BRM_DASHBOARD_V2 = (response && response.SHOW_BRM_DASHBOARD_V2) || false;
        this.SHOW_WRITEOFF_PROMOTION = (response && response.SHOW_WRITEOFF_PROMOTION) || false;
        this.BUFFER_SIZE = (response && response.BUFFER_SIZE) || 1000;
        this.LOG_TIMEOUT = (response && response.LOG_TIMEOUT) || 60000;
        this.MONIEPOINT_URL = (response && response.MONIEPOINT_URL) || 'https://moniepoint.development.teamapt.com';
        this.SHOW_YEARLY_SUMMARY_REPORT = (response && response.SHOW_YEARLY_SUMMARY_REPORT) || false;
        this.SHOW_TERMS_AND_CONDITIONS_MODAL_BO = (response && response.SHOW_TERMS_AND_CONDITIONS_MODAL_BO) || false;
        this.SHOW_TERMS_AND_CONDITIONS_MODAL_BRM = (response && response.SHOW_TERMS_AND_CONDITIONS_MODAL_BRM) || false;
        this.SHOW_TERMS_AND_CONDITIONS_MODAL_RM = (response && response.SHOW_TERMS_AND_CONDITIONS_MODAL_RM) || false;
        this.SHOW_TERMS_AND_CONDITIONS_MODAL_SC = (response && response.SHOW_TERMS_AND_CONDITIONS_MODAL_SC) || false;
        this.SHOW_SWITCH_TO_REG_BUSINESS = (response && response.SHOW_SWITCH_TO_REG_BUSINESS) || false;
        this.SHOW_BRM_CASHOUT_PIN_FLOW = (response && response.SHOW_BRM_CASHOUT_PIN_FLOW) || false;
        this.SHOW_DASHBOARD_ALERT_WIDGET = (response && response.SHOW_DASHBOARD_ALERT_WIDGET) || false;
        this.JWT_EXPIRY_CHECK = (response && response.JWT_EXPIRY_CHECK) || 60000;
        this.SHOW_BRM_WRITEOFF_ACTION = (response && response.SHOW_BRM_WRITEOFF_ACTION) || false;
        this.SHOW_BRM_RESET_PIN_FLOW = (response && response.SHOW_BRM_RESET_PIN_FLOW) || false;
        this.SHOW_BUSINESS_EFFICIENCY_UPDATE = (response && response.SHOW_BUSINESS_EFFICIENCY_UPDATE) || false;
        this.META_MAP_BRM_PROFLIE_VERIFICATION_LIVELINESS_FLOW_ID =
            (response && response.META_MAP_BRM_PROFLIE_VERIFICATION_LIVELINESS_FLOW_ID) || '63b3e2aa78cbe0001c640748';
        this.SHOW_BRM_VERIFICATION_METAMAP_LIVELINESS_FLOW = (response && response.SHOW_BRM_VERIFICATION_METAMAP_LIVELINESS_FLOW) || false;
        this.SHOW_EOD_PRINTING = (response && response.SHOW_EOD_PRINTING) || false;
        this.SHOW_SELF_TEST = (response && response.SHOW_SELF_TEST) || false;
        this.RM_ONBOARDING_URL = (response && response.RM_ONBOARDING_URL) || 'https://rm.onboarding.mab.development.teamapt.com';
        this.SHOW_STAFF_USERS_MENU = (response && response.SHOW_STAFF_USERS_MENU) || false;
        this.SHOW_STAFF_DESIGNATION_MENU = (response && response.SHOW_STAFF_DESIGNATION_MENU) || false;
        this.SHOW_TERMINAL_ASSIGNMENT_UPDATE = (response && response.SHOW_TERMINAL_ASSIGNMENT_UPDATE) || false;
        this.USE_V2_SELECTION_PAGE = (response && response.USE_V2_SELECTION_PAGE) || false;
        this.SHOW_ONBOARDING_SUPPORT = (response && response.SHOW_ONBOARDING_SUPPORT) || false;
        this.SHOW_COURSES_WARNING_ON_CASHOUT = (response && response.SHOW_COURSES_WARNING_ON_CASHOUT) || false;
        this.STAFF_USER_DEPOSIT_REQUEST = (response && response.STAFF_USER_DEPOSIT_REQUEST) || false;
        this.STAFF_USER_AIRTIME_REQUEST = (response && response.STAFF_USER_AIRTIME_REQUEST) || false;
        this.STAFF_USER_BILL_PAYMENT_REQUEST = (response && response.STAFF_USER_BILL_PAYMENT_REQUEST) || false;
        this.SHOW_RECURRING_TRANSFER_LIMIT = (response && response.SHOW_RECURRING_TRANSFER_LIMIT) || false;
        this.SHOW_INFINITE_RECURRING_TRANSFER = (response && response.SHOW_INFINITE_RECURRING_TRANSFER) || false;
        this.SHOW_BO_NEW_APPROVALS_UI = (response && response.SHOW_BO_NEW_APPROVALS_UI) || false;
        this.SHOW_BO_DEFAULT_APPROVAL_UI_NEW = (response && response.SHOW_BO_DEFAULT_APPROVAL_UI_NEW) || false;
        this.SHOW_APP_DOWNLOAD_BANNER = (response && response.SHOW_APP_DOWNLOAD_BANNER) || false;
        this.USE_NEW_ONBOARDING_FLOW = (response && response.USE_NEW_ONBOARDING_FLOW) || false;
        this.USE_NEW_SIGN_UP_FLOW = (response && response.USE_NEW_SIGN_UP_FLOW) || false;
        this.USE_NEW_KYC_FLOW = (response && response.USE_NEW_KYC_FLOW) || false;
        this.MONIEPOINT_ORCHESTRATOR_SERVICE =
            (response && response.MONIEPOINT_ORCHESTRATOR_SERVICE) || 'notification-orchestrator.development.moniepoint.com';
        this.SHOW_NOTIFICATION_PREFERENCE = (response && response.SHOW_NOTIFICATION_PREFERENCE) || '';
        this.SHOW_DOWNLOADABLE_MATERIAL = (response && response.SHOW_DOWNLOADABLE_MATERIAL) || false;
        this.SHOW_NEW_ACCOUNT_VIEW = (response && response.SHOW_NEW_ACCOUNT_VIEW) || false;
        this.SHOW_NEW_TRANSFER = (response && response.SHOW_NEW_TRANSFER) || false;
        this.SHOW_TRANSFER_LIMIT_MODAL = (response && response.SHOW_TRANSFER_LIMIT_MODAL) || false;
        this.REMOVE_TRANSFER_ALL_TRANSACTIONS = (response && response.REMOVE_TRANSFER_ALL_TRANSACTIONS) || false;
        this.SHOW_NEW_TRANSFER_EXPORT_URL = (response && response.SHOW_NEW_TRANSFER_EXPORT_URL) || false;
        this.ROUTE_TO_DASHBOARD_AFTER_ONBOARDING = (response && response.ROUTE_TO_DASHBOARD_AFTER_ONBOARDING) || false;
        this.USE_MOBILE_MAX_FILE_SIZE = (response && response.USE_MOBILE_MAX_FILE_SIZE) || false;
        this.DEFAULT_TIME_FOR_METAMAP_STATUS_CALL = (response && response.DEFAULT_TIME_FOR_METAMAP_STATUS_CALL) || 60;
        this.SET_DEFAULT_NOTIFICATION_PREFERENCE = (response && response.SET_DEFAULT_NOTIFICATION_PREFERENCE) || false;
        this.SHOW_LOGIN_USSD = (response && response.SHOW_LOGIN_USSD) || false;
        this.HIDE_BUSINESSES_FOR_INVITE_ADMIN = (response && response.HIDE_BUSINESSES_FOR_INVITE_ADMIN) || false;
        this.SHOW_NEW_FLOW_INVITE_STAFF = (response && response.SHOW_NEW_FLOW_INVITE_STAFF) || false;
        this.SHOW_TERMINAL_ASSIGNMENT_BUSINESS_UPDATE = (response && response.SHOW_TERMINAL_ASSIGNMENT_BUSINESS_UPDATE) || false;
        AppConfig.SHOW_BRM_BUSINESS_ACCOUNT = (response && response.SHOW_BRM_BUSINESS_ACCOUNT) || false;
        AppConfig.SHOW_BRM_APPROVE_TAB = (response && response.SHOW_BRM_APPROVE_TAB) || false;
        AppConfig.SHOW_BRM_ONBOARDING_FOR_CM = (response && response.SHOW_BRM_ONBOARDING_FOR_CM) || false;
        AppConfig.SHOW_DOCUMENT_APPROVE_TAB = (response && response.SHOW_DOCUMENT_APPROVE_TAB) || false;
        AppConfig.SHOW_LIMIT_APPROVE_TAB = (response && response.SHOW_LIMIT_APPROVE_TAB) || false;
        AppConfig.SHOW_BUSINESS_EARNINGS = (response && response.SHOW_BUSINESS_EARNINGS) || false;
        AppConfig.SHOW_BRM_ONBOARDING = (response && response.SHOW_BRM_ONBOARDING) || false;
        AppConfig.SHOW_ALL_COMMISSIONS = (response && response.SHOW_ALL_COMMISSIONS) || false;
        AppConfig.SHOW_BUSINESS_ACCOUNT_CASHOUT_BUTTON = (response && response.SHOW_BUSINESS_ACCOUNT_CASHOUT_BUTTON) || false;
        AppConfig.TRACK_EVENT = (response && response.TRACK_EVENT) || false;
        AppConfig.CAN_SHOW_PARTNERS_DEPOSIT_COMMISSIONS_BALANCE = (response && response.CAN_SHOW_PARTNERS_DEPOSIT_COMMISSIONS_BALANCE) || false;
        this.EXTENDED_STATEMENT_DOWNLOAD = (response && response.EXTENDED_STATEMENT_DOWNLOAD) || false;
        this.BUSINESS_OWNER_EXTENDED_STATEMENT_DOWNLOAD = (response && response.BUSINESS_OWNER_EXTENDED_STATEMENT_DOWNLOAD) || false;
        this.DAILY_BUSINESS_STATEMENT_DOWNLOAD = (response && response.DAILY_BUSINESS_STATEMENT_DOWNLOAD) || false;
        this.DAILY_TERMINAL_STATEMENT_DOWNLOAD = (response && response.DAILY_TERMINAL_STATEMENT_DOWNLOAD) || false;
        this.SHOW_BUSINESS_OWNER_STATEMENT_EXPORT = (response && response.SHOW_BUSINESS_OWNER_STATEMENT_EXPORT) || false;
        this.SHOW_USER_PIN_MENU = (response && response.SHOW_USER_PIN_MENU) || false;
        this.USE_NEW_META_MAP_BUTTON = (response && response.USE_NEW_META_MAP_BUTTON) || false;
        this.SHOW_KYC_LEVEL_BANNER = (response && response.SHOW_KYC_LEVEL_BANNER) || false;
        this.MONIEPOINT_CRM_SERVICE = (response && response.MONIEPOINT_CRM_SERVICE) || 'https://moniepoint-crm-service.development.teamapt.com';
        this.ENABLE_STAFF_USER_INVITE = (response && response.ENABLE_STAFF_USER_INVITE) || false;
        this.SHOW_CARD_PENETRATION_WIDGET = (response && response.SHOW_CARD_PENETRATION_WIDGET) || false;
        this.SHOW_OLD_TRANSACTION_PIN_MENU = (response && response.SHOW_OLD_TRANSACTION_PIN_MENU) || false;
        this.USE_NEW_TRANSACTION_PIN = (response && response.USE_NEW_TRANSACTION_PIN) || false;
        this.SHOW_KYC_TRANSACTION_LIMITS = (response && response.SHOW_KYC_TRANSACTION_LIMITS) || false;
        AppConfig.USE_NEW_WITHDRAWAL = (response && response.USE_NEW_WITHDRAWAL) || false;
        AppConfig.USE_NEW_PURCHASE = (response && response.USE_NEW_PURCHASE) || false;
        AppConfig.USE_NEW_AIRTIME = (response && response.USE_NEW_AIRTIME) || false;
        this.SHOW_USER_PIN_MODAL_ON_BO_LOGIN = (response && response.SHOW_USER_PIN_MODAL_ON_BO_LOGIN) || false;
        this.SHOW_SC_TERMINAL_ASSIGNMENT = (response && response.SHOW_SC_TERMINAL_ASSIGNMENT) || false;
        this.USE_CONSOLIDATED_ALL_FOR_ALL_TRANSACTIONS = (response && response.USE_CONSOLIDATED_ALL_FOR_ALL_TRANSACTIONS) || false;
        this.SHOW_BO_DASHBOARD_FOR_DIGITAL_BO = (response && response.SHOW_BO_DASHBOARD_FOR_DIGITAL_BO) || false;
        this.CAN_OPEN_BO_DIGITAL_ACCOUNT = (response && response.CAN_OPEN_BO_DIGITAL_ACCOUNT) || false;
        this.CARDS_CAN_USE_USER_PIN = (response && response.CARDS_CAN_USE_USER_PIN) || false;
        this.MONIEPOINT_DELIVERY_SERVICE = (response && response.MONIEPOINT_DELIVERY_SERVICE) || '';
        this.CAN_USE_DELIVERY_SERVICE = (response && response.CAN_USE_DELIVERY_SERVICE) || false;
        this.SHOW_BO_TABLE_V2 = (response && response.SHOW_BO_TABLE_V2) || false;
        this.SHOW_POS_UPDATE = (response && response.SHOW_POS_UPDATE) || false;
        this.SHOW_SWAP_TERMINAL_UPDATE = (response && response.SHOW_SWAP_TERMINAL_UPDATE) || false;
        this.CAN_USE_SUBLGA = (response && response.CAN_USE_SUBLGA) || false;
        this.CAN_BRM_EXTEND_GRACE_PERIOD_AFTER_EXPIRATION = (response && response.CAN_BRM_EXTEND_GRACE_PERIOD_AFTER_EXPIRATION) || false;
        this.TIME_ZONE = (response && response.TIME_ZONE) || 'Africa/Lagos';
        this.WEB_BICON = (response && response.WEB_BICON) || false;
        this.USE_NEW_LOGIN_API = (response && response.USE_NEW_LOGIN_API) || false;
        this.USE_KYC_API_ON_DASHBOARD = (response && response.USE_KYC_API_ON_DASHBOARD) || false;
        this.SHOW_TERMINAL_COMMISSION_FEE_SPLIT = (response && response.SHOW_TERMINAL_COMMISSION_FEE_SPLIT) || false;
        this.CAN_ADD_BUSINESSES_FOR_PENDING_BO = (response && response.CAN_ADD_BUSINESSES_FOR_PENDING_BO) || false;
        this.CAN_USE_SOFT_ONBOARDING = (response && response.CAN_USE_SOFT_ONBOARDING) || false;
        this.CARDS_CAN_COLLECT_CARDS = (response && response.CARDS_CAN_COLLECT_CARDS) || false;
        this.SHOW_PROFILE_BUTTON_ON_BO_PROFILE = (response && response.SHOW_PROFILE_BUTTON_ON_BO_PROFILE) || false;
        this.USE_UUID_FOR_DEVICE_ID = (response && response.USE_UUID_FOR_DEVICE_ID) || false;
        this.USE_NIBSS_BVN_VERIFICATION = (response && response.USE_NIBSS_BVN_VERIFICATION) || false;
        this.USE_OTP_CHANGE_PASSWORD_AND_PIN = (response && response.USE_OTP_CHANGE_PASSWORD_AND_PIN) || false;
        this.USE_NEW_CHANGE_PASSWORD = (response && response.USE_NEW_CHANGE_PASSWORD) || false;
        this.USE_NEW_RESET_USER_PIN = (response && response.USE_NEW_RESET_USER_PIN) || false;
        this.USE_NEW_STATEMENT_FLOW = (response && response.USE_NEW_STATEMENT_FLOW) || false;
        this.SHOULD_USE_NEW_BVN_FLOW = (response && response.SHOULD_USE_NEW_BVN_FLOW) || false;
        this.SHOW_BRM_CARD_SALES_AGENT = (response && response.SHOW_BRM_CARD_SALES_AGENT) || false;
        this.SHOW_BRM_CARD_NEW_UI = (response && response.SHOW_BRM_CARD_NEW_UI) || false;
        this.SHOW_SC_TERMINAL_SWAP = (response && response.SHOW_SC_TERMINAL_SWAP) || false;
        this.USE_OLD_BUSINESS_OWNER_KYC = (response && response.USE_OLD_BUSINESS_OWNER_KYC) || false;
        this.HIDE_PDF_STATEMENT_DOWNLOAD = (response && response.HIDE_PDF_STATEMENT_DOWNLOAD) || false;
        this.USE_NEW_BO_STATEMENT_DOWNLOAD = (response && response.USE_NEW_BO_STATEMENT_DOWNLOAD) || false;
        this.CAN_USE_BUSINESS_NAME_CHANGE = (response && response.CAN_USE_BUSINESS_NAME_CHANGE) || false;
        AppConfig.SHOW_REFERRALS = (response && response.SHOW_REFERRALS) || false;
        AppConfig.SHOULD_SHOW_REWARDS_V2 = (response && response.SHOULD_SHOW_REWARDS_V2) || false;
        AppConfig.SHOULD_USE_UNIFIED_BANNER = (response && response.SHOULD_USE_UNIFIED_BANNER) || false;
        this.SHOW_REFERRALS_CASHOUT = (response && response.SHOW_REFERRALS_CASHOUT) || false;
        this.SHOW_BULK_TRANSFER = (response && response.SHOW_BULK_TRANSFER) || false;
        this.ADD_BUSINESS_DETAILS_MENU = (response && response.ADD_BUSINESS_DETAILS_MENU) || false;
        this.SHOW_POS_ERP_INTEGRATION = (response && response.SHOW_POS_ERP_INTEGRATION) || false;
        this.CAN_USE_SMILE_ID = (response && response.CAN_USE_SMILE_ID) || false;
        this.USE_OVERDRAFT_PAYMENT = (response && response.USE_OVERDRAFT_PAYMENT) || false;
        this.SHOW_COLLECT_CARD_MENU = (response && response.SHOW_COLLECT_CARD_MENU) || false;
        AppConfig.SHOW_NEW_TERMINAL_ASSIGNMENT_REQUESTS = (response && response.SHOW_NEW_TERMINAL_ASSIGNMENT_REQUESTS) || false;
        this.SHOW_ACCOUNT_CLOSURE = (response && response.SHOW_ACCOUNT_CLOSURE) || false;
        this.SHOW_BRM_PUSH_CARDS_TO_SALES_AGENT = (response && response.SHOW_BRM_PUSH_CARDS_TO_SALES_AGENT) || false;
        this.MONIEPOINT_APPLICATION_STORE_URL = (response && response.MONIEPOINT_APPLICATION_STORE_URL) || '';
        this.REFERRAL_PRE_REGISTRATION_API_RETRY_COUNT = (response && response.REFERRAL_PRE_REGISTRATION_API_RETRY_COUNT) || 10;
        this.REFERRAL_PRE_REGISTRATION_API_RETRY_INTERVAL = (response && response.REFERRAL_PRE_REGISTRATION_API_RETRY_INTERVAL) || 2000;
        this.BRM_PUSH_TO_SALES_AGENT_CARD_COUNT = (response && response.BRM_PUSH_TO_SALES_AGENT_CARD_COUNT) || 5;
        this.BRM_CAN_RETRIEVE_CARDS = (response && response.BRM_CAN_RETRIEVE_CARDS) || false;
        this.SHOW_NEW_PROFILE_UPDATE_VIEW = (response && response.SHOW_NEW_PROFILE_UPDATE_VIEW) || false;
        this.USE_KYC_NIN_FLOW = (response && response.USE_KYC_NIN_FLOW) || false;
        this.BRM_CAN_USE_FLEXIBLE_CARD_COST = (response && response.BRM_CAN_USE_FLEXIBLE_CARD_COST) || false;
        this.USE_BRM_KYC_NIN_FLOW = (response && response.USE_BRM_KYC_NIN_FLOW) || false;
        this.CAN_USE_IDENTITY_TOKEN = (response && response.CAN_USE_IDENTITY_TOKEN) || false;
        this.USE_LOGIN_OPTION = (response && response.USE_LOGIN_OPTION) || false;
        this.CAN_CHANGE_PASSCODE = (response && response.CAN_CHANGE_PASSCODE) || false;
        this.SHOW_SIGN_UP_PASSCODE_FLOW = (response && response.SHOW_SIGN_UP_PASSCODE_FLOW) || false;
        this.USE_CARD_PUSH_BATCH_SETTINGS = (response && response.USE_CARD_PUSH_BATCH_SETTINGS) || false;
        this.SHOW_USSD_BANKING_CHANNEL_SETTINGS = (response && response.SHOW_USSD_BANKING_CHANNEL_SETTINGS) || false;
        this.USSD_BANKING_CHANNEL_MODAL_MAXIMUM_USERS = (response && response.USSD_BANKING_CHANNEL_MODAL_MAXIMUM_USERS) || 5;
        this.USE_NEW_FORGET_PASSCODE_FLOW = (response && response.USE_NEW_FORGET_PASSCODE_FLOW) || false;
        this.USE_ACCOUNT_NUMBER_ALIAS = (response && response.USE_ACCOUNT_NUMBER_ALIAS) || false;
        this.VALIDATE_DUPLICATE_TRANSFERS = (response && response.VALIDATE_DUPLICATE_TRANSFERS) || false;
        this.SHOW_TERMINAL_TRANSACTION_WIDGET = (response && response.SHOW_TERMINAL_TRANSACTION_WIDGET) || true;
        this.SHOW_CARD_SALES_SUMMARY = (response && response.SHOW_CARD_SALES_SUMMARY) || true;
        this.USE_NEW_KYC_LEVEL2_FLOW = (response && response.USE_NEW_KYC_LEVEL2_FLOW) || false;
        this.USE_NEW_KYC_LEVEL3_FLOW = (response && response.USE_NEW_KYC_LEVEL3_FLOW) || false;
        this.CAN_HIDE_KYC_LEVEL1_PRIMER = (response && response.CAN_HIDE_KYC_LEVEL1_PRIMER) || false;
        this.USE_NEW_BRM_KYC_LEVEL2_FLOW = (response && response.USE_NEW_BRM_KYC_LEVEL2_FLOW) || false;
        this.USE_NEW_BRM_KYC_LEVEL3_FLOW = (response && response.USE_NEW_BRM_KYC_LEVEL3_FLOW) || false;
        this.REWARD_SERVICE_URL = (response && response.REWARD_SERVICE_URL) || 'https://moniepoint-rewards-service.development.moniepoint.com';
        this.SHOULD_SHOW_REWARDS = (response && response.SHOULD_SHOW_REWARDS) || false;
        this.BRM_CAN_USE_CONFIG_FLEXIBLE_CARD_COST = (response && response.BRM_CAN_USE_CONFIG_FLEXIBLE_CARD_COST) || false;
        this.SHOW_TERMINAL_ACTIVITY_SCORE = (response && response.SHOW_TERMINAL_ACTIVITY_SCORE) || false;
        this.USE_PROFILE_SETUP = (response && response.USE_PROFILE_SETUP) || false;
        this.USE_CARD_DEVICE_ID = (response && response.USE_CARD_DEVICE_ID) || false;
        this.USSD_BANKING_CODE = (response && response.USSD_BANKING_CODE) || '*5573#';
        this.USE_STAFF_USER_REFRESH_TOKEN = (response && response.USE_STAFF_USER_REFRESH_TOKEN) || false;
        this.CAN_RESEND_OTP_VIA_WHATSAPP = (response && response.CAN_RESEND_OTP_VIA_WHATSAPP) || false;
        this.CAN_USE_NEW_USSD = (response && response.CAN_USE_NEW_USSD) || false;
        this.SHOW_BO_PERFORMANCE = (response && response.SHOW_BO_PERFORMANCE) || false;
        this.USE_KAMONA_SIGN_IN = (response && response.USE_KAMONA_SIGN_IN) || false;
        this.SHOW_CAC_BANNER = (response && response.SHOW_CAC_BANNER) || false;
        this.SHOW_BRM_CAC_INCOMPLIANT_BO = (response && response.SHOW_BRM_CAC_INCOMPLIANT_BO) || false;
        this.USE_DEVICE_ID_DECRYPTION = (response && response.USE_DEVICE_ID_DECRYPTION) || false;
        this.USE_ASYNC_LIVELINESS_CHECK = (response && response.USE_ASYNC_LIVELINESS_CHECK) || false;
        this.SHOW_UPDATE_DATE_OF_BIRTH = (response && response.SHOW_UPDATE_DATE_OF_BIRTH) || false;
        AppConfig.SHOW_LOAN_PREQUALIFICATION_AGGREGATORS = (response && response.SHOW_LOAN_PREQUALIFICATION_AGGREGATORS) || false;
        AppConfig.SHOW_LOAN_PREQUALIFICATION_RC = (response && response.SHOW_LOAN_PREQUALIFICATION_RC) || false;
        AppConfig.SHOW_LOAN_AGGREGATORS_PREQUALIFICATION_LOOKUP = (response && response.SHOW_LOAN_AGGREGATORS_PREQUALIFICATION_LOOKUP) || false;
        AppConfig.SHOW_LOAN_AGGREGATORS_PREQUALIFICATION_LOOKUP_V2 = (response && response.SHOW_LOAN_AGGREGATORS_PREQUALIFICATION_LOOKUP_V2) || false;
        this.USE_PREQUALIFIED_BOS_V2 = response?.USE_PREQUALIFIED_BOS_V2 || false;
        this.USE_PREQUALIFICATION_LOOKUP_V2 = response?.USE_PREQUALIFICATION_LOOKUP_V2 || false;
        AppConfig.SHOW_LOAN_AGGREGATORS_SCHEDULE_SIMULATION = (response && response.SHOW_LOAN_AGGREGATORS_SCHEDULE_SIMULATION) || false;
        this.FO_ENVIRONMENT = (response && response.FO_ENVIRONMENT) || 'local';
        this.TELEMETRY_ENABLE = response?.TELEMETRY_ENABLE ?? false;
        this.TELEMETRY_BASE_URL = response?.TELEMETRY_BASE_URL ?? 'https://hermes-ingest.moniepointinc.com/v1';
        this.TELEMETRY_SERVICE_NAME = response?.TELEMETRY_SERVICE_NAME ?? 'moniepoint-frontoffice-web';
        this.TELEMETRY_DEBUG_MODE = response?.TELEMETRY_DEBUG_MODE ?? false;
        this.TELEMETRY_DEV_MODE = response?.TELEMETRY_DEV_MODE ?? false;
        this.TELEMETRY_INTERVAL_MILLIS = response?.TELEMETRY_INTERVAL_MILLIS ?? 20_000;
        this.SHOW_INCOMPLIANT_KYC_BANNER = (response && response.SHOW_INCOMPLIANT_KYC_BANNER) || false;
        this.SHOW_BRM_INCOMPLIANT_KYC_BANNER = (response && response.SHOW_BRM_INCOMPLIANT_KYC_BANNER) || false;
        this.USE_AUTO_ADDRESS_APPROVAL = (response && response.USE_AUTO_ADDRESS_APPROVAL) || false;
        this.CARDS_REQUIRE_TERMS_AND_CONDITIONS = (response && response.CARDS_REQUIRE_TERMS_AND_CONDITIONS) || false;
        AppConfig.SHOW_INVENTORY = (response && response.SHOW_INVENTORY) || false;
        this.ENABLE_LIVENESS_FOR_CARD_ACTIVATION = (response && response.ENABLE_LIVENESS_FOR_CARD_ACTIVATION) || false;
        this.CARD_TOOLS_UI_UPDATE_V1 = (response && response.CARD_TOOLS_UI_UPDATE_V1) || false;
        this.USE_MERGE_DUPLICATE_PROFILE_FLOW = (response && response.USE_MERGE_DUPLICATE_PROFILE_FLOW) ?? true;
        this.ALLOW_SIGN_UP_FOR_BRM = (response && response.ALLOW_SIGN_UP_FOR_BRM) || false;
        this.ALLOW_BRM_ADD_BUSINESS = (response && response.ALLOW_BRM_ADD_BUSINESS) || false;
        this.ALLOW_BRM_USE_PASSPORT_PHOTOGRAPH_FOR_BO_ONBOARDING =
            (response && response.ALLOW_BRM_USE_PASSPORT_PHOTOGRAPH_FOR_BO_ONBOARDING) || false;
        this.ALLOW_BVN_FOR_KYC_LEVEL_1_BUSINESS_ONBOARDING = (response && response.ALLOW_BVN_FOR_KYC_LEVEL_1_BUSINESS_ONBOARDING) || false;
        this.VALIDATE_BO_WCL_KYC = (response && response.VALIDATE_BO_WCL_KYC) || false;
        this.USE_LOAN_EXPIRED_V2 = (response && response.USE_LOAN_EXPIRED_V2) || false;
        this.USE_PENDING_LOAN_TIMELINE_V2 = (response && response.USE_PENDING_LOAN_TIMELINE_V2) || false;
        this.USE_GOOGLE_MAP_JAVASCRIPT_API = (response && response.USE_GOOGLE_MAP_JAVASCRIPT_API) || false;
        this.GEOLOCATION_THRESHOLD_IN_METER = (response && response.GEOLOCATION_THRESHOLD_IN_METER) || 500;
        this.USE_ADDRESS_REVALIDATION = (response && response.USE_ADDRESS_REVALIDATION) || false;
        this.SHOW_TERMINAL_QUOTA_UPDATE = (response && response.SHOW_TERMINAL_QUOTA_UPDATE) || false;
        this.USE_PEP_NATIONALITY_INCOME_LEVEL_1_FLOW = (response && response.USE_PEP_NATIONALITY_INCOME_LEVEL_1_FLOW) || false;
        this.USE_BRM_PEP_NATIONALITY_INCOME_LEVEL_1_FLOW = (response && response.USE_BRM_PEP_NATIONALITY_INCOME_LEVEL_1_FLOW) || false;
        this.SHOW_BRM_LGA_UPDATE_ON_FVS_VIEW = (response && response.SHOW_BRM_LGA_UPDATE_ON_FVS_VIEW) || false;
        this.SHOW_FVS_ADDRESS_VERIFICATION_ROUTES = (response && response.SHOW_FVS_ADDRESS_VERIFICATION_ROUTES) || false;
        AppConfig.SHOW_FVS_ADDRESS_VERIFICATION_MENU = (response && response.SHOW_FVS_ADDRESS_VERIFICATION_MENU) || false;
        AppConfig.FVS_ADDRESS_VERIFICATION_TABS_TO_HIDE = (response && response.FVS_ADDRESS_VERIFICATION_TABS_TO_HIDE) || '';
        this.SHOW_FVS_PENDING_COUNT_BANNER_ON_BRM_DASHBOARD = (response && response.SHOW_FVS_PENDING_COUNT_BANNER_ON_BRM_DASHBOARD) || false;
        this.FVS_SHOW_ADDRESS_VERIFICATION_WIDGET = (response && response.FVS_SHOW_ADDRESS_VERIFICATION_WIDGET) || false;
        this.FVS_SHOW_BRM_CAN_UPDATE_BO_ADDRESS = (response && response.FVS_SHOW_BRM_CAN_UPDATE_BO_ADDRESS) || false;
        this.FVS_LOGIN_ROUTE_WITH_QUERY_PARAM =
            (response && response.FVS_LOGIN_ROUTE_WITH_QUERY_PARAM) || 'https://fv.fo-ui.development.teamapt.com/login-with-moniepoint?token=';
        this.ALLOW_BRM_RE_UPDATE_LGA_ON_FVS = (response && response.ALLOW_BRM_RE_UPDATE_LGA_ON_FVS) || false;
        this.USE_NEW_COMPLIANCE_URLS = response?.USE_NEW_COMPLIANCE_URLS || false;
        this.MINIMUM_ADDRESS_VERIFICATION_TIME_IN_DAYS = response?.MINIMUM_ADDRESS_VERIFICATION_TIME_IN_DAYS || 7;
        this.COUNTRY_FLAGS_URL = response?.COUNTRY_FLAGS_URL || 'https://cdn-prod.moniepoint.com/country-flags/';
        this.MAXIMUM_ADDRESS_VERIFICATION_TIME_IN_DAYS = response?.MAXIMUM_ADDRESS_VERIFICATION_TIME_IN_DAYS || 14;
        this.SHOW_ADDRESS_VERIFICATION_POP_UP_EVERY_LOGIN = response?.SHOW_ADDRESS_VERIFICATION_POP_UP_EVERY_LOGIN || false;
        this.USE_CAC_BUSINESS_AFFILIATE_FLOW = response?.USE_CAC_BUSINESS_AFFILIATE_FLOW || false;
        this.SHOW_SWAP_UPDATE_FOR_SC_AND_BRM = response?.SHOW_SWAP_UPDATE_FOR_SC_AND_BRM || false;
        this.METAMAP_SCRIPT_URL = response?.METAMAP_SCRIPT_URL;
        this.USE_MOCK_PEP_ISSUES_DATA = response?.USE_MOCK_PEP_ISSUES_DATA;
        this.USE_KYC_CORRECTIONS_V2 = response?.USE_KYC_CORRECTIONS_V2 || false;
        this.USE_PHYSICAL_ADDRESS_VERIFICATION_FOR_KYC = response?.USE_PHYSICAL_ADDRESS_VERIFICATION_FOR_KYC || false;
        this.USE_PHYSICAL_ADDRESS_VERIFICATION_FOR_BRM_KYC = response?.USE_PHYSICAL_ADDRESS_VERIFICATION_FOR_BRM_KYC || false;
        this.USE_REGISTERED_BUSINESS_PRIMER_LABEL = response?.USE_REGISTERED_BUSINESS_PRIMER_LABEL || false;
        this.USE_REGISTERED_BUSINESS_ROUTE = response?.USE_REGISTERED_BUSINESS_ROUTE || false;
        this.SHOW_NEW_FAULTY_FLOW = response?.SHOW_NEW_FAULTY_FLOW || false;
        this.SC_PERFORMANCE_START_PERIOD = (response && response.SC_PERFORMANCE_START_PERIOD) || '04-2024';
        this.USE_LOOM_MFA_SDK = response?.USE_LOOM_MFA_SDK || false;
        this.SHOW_TERMINAL_RETRIEVAL_UPDATE = response?.SHOW_TERMINAL_RETRIEVAL_UPDATE || false;
        AppConfig.SHOW_MY_APPROVAL_REQUESTS = (response && response.SHOW_MY_APPROVAL_REQUESTS) || false;
        this.CAN_MAKE_STATE_LGA_OPTIONAL = response?.CAN_MAKE_STATE_LGA_OPTIONAL || false;
        this.USE_DAILY_STATEMENT_DATE_RANGE = response?.USE_DAILY_STATEMENT_DATE_RANGE || false;
        this.SHOW_GLOBAL_SWAP_UPDATE = response?.SHOW_GLOBAL_SWAP_UPDATE || false;
        this.USE_STATEMENT_REPORT_URL = response?.USE_STATEMENT_REPORT_URL || false;
        this.MONIEPOINT_STATEMENT = response?.MONIEPOINT_STATEMENT || '';
        this.MONIEDESK_API_BASE_URL = response?.MONIEDESK_API_BASE_URL || '';
        this.MONIEDESK_CRM_SERVICE = response?.MONIEDESK_CRM_SERVICE || '';
        this.MONIEDESK_ENTITY = response?.MONIEDESK_ENTITY || '';
        this.MINIMUM_MFA_SIGN_UP_ALERT_KYC_LEVEL = response?.MINIMUM_MFA_SIGN_UP_ALERT_KYC_LEVEL || 0;
        this.MINIMUM_MFA_SIGN_UP_ALERT_TEXT = response?.MINIMUM_MFA_SIGN_UP_ALERT_TEXT || '';
        this.USE_NEW_DAILY_LIMIT_FLOW = response?.USE_NEW_DAILY_LIMIT_FLOW || false;
        this.ENFORCE_ADDRESS_VERIFICATION_NEW_DAILY_LIMIT_FLOW = response?.ENFORCE_ADDRESS_VERIFICATION_NEW_DAILY_LIMIT_FLOW || false;
        this.ENFORCE_OPTION_ADDRESS_VERIFICATION_NEW_DAILY_LIMIT_FLOW = response?.ENFORCE_OPTION_ADDRESS_VERIFICATION_NEW_DAILY_LIMIT_FLOW || false;
        this.OTP_RESEND_V2 = response?.OTP_RESEND_V2 || false;
        this.USE_2FA_FLOW_USER_PIN_RESET = response?.USE_2FA_FLOW_USER_PIN_RESET || false;
        this.USE_2FA_FLOW_FORGOT_PASSCODE = response?.USE_2FA_FLOW_FORGOT_PASSCODE || false;
        this.USE_2FA_FLOW_FORGOT_PASSWORD = response?.USE_2FA_FLOW_FORGOT_PASSWORD || false;
        this.USE_2FA_FLOW_PASSCODE_CHANGE = response?.USE_2FA_FLOW_PASSCODE_CHANGE || false;
        this.USE_2FA_FLOW_PASSWORD_CHANGE = response?.USE_2FA_FLOW_PASSWORD_CHANGE || false;
        this.SHOW_KYC_LVL1_BUSINESS_NAME_DESCRIPTION_SIZE = response?.SHOW_KYC_LVL1_BUSINESS_NAME_DESCRIPTION_SIZE || false;
        this.USE_ONBOARDING_MODULE_LAZY_LOADER = response?.USE_ONBOARDING_MODULE_LAZY_LOADER || false;
        this.USE_NEW_LOAN_FACILITATOR_INPUT = response?.USE_NEW_LOAN_FACILITATOR_INPUT || false;
        this.SHOW_PND_AND_LIENS_BANNER = response?.SHOW_PND_AND_LIENS_BANNER || false;
        this.SHOW_SC_RM_CASHOUT = response?.SHOW_SC_RM_CASHOUT || false;
        this.SHOW_BRM_PRM_CASHOUT = response?.SHOW_BRM_PRM_CASHOUT || false;
        AppConfig.SHOW_PRM_PERFORMANCE_TRACKER = response?.SHOW_PRM_PERFORMANCE_TRACKER || false;
        AppConfig.ENABLE_SUB_BRM = response?.ENABLE_SUB_BRM || false;
        AppConfig.SHOW_KIOSK_MARKETERS = response?.SHOW_KIOSK_MARKETERS || false;
        AppConfig.SHOW_SC_PERFORMANCE_REPORTS = response?.SHOW_SC_PERFORMANCE_REPORTS || false;
        AppConfig.SHOW_SPO_PERFORMANCE_TRACKER = response?.SHOW_SPO_PERFORMANCE_TRACKER || false;
        AppConfig.SHOW_BUSINESS_REMAPPING = response?.SHOW_BUSINESS_REMAPPING || false;
        AppConfig.SHOW_ACCOUNTS_MENU_FOR_CM = response?.SHOW_ACCOUNTS_MENU_FOR_CM || false;
        AppConfig.SHOW_WELFARE_ACCOUNT_FOR_BRM = response?.SHOW_WELFARE_ACCOUNT_FOR_BRM || false;
        AppConfig.SHOW_WELFARE_ACCOUNT_FOR_SC = response?.SHOW_WELFARE_ACCOUNT_FOR_SC || false;
        AppConfig.SHOW_WELFARE_ACCOUNT_FOR_RM = response?.SHOW_WELFARE_ACCOUNT_FOR_RM || false;
        this.SHOW_BRM_ONBOARDING_NEXT_OF_KIN = response?.SHOW_BRM_ONBOARDING_NEXT_OF_KIN || false;
        this.SHOW_BRM_BUSINESS_RECATEGORIZATION_NOTIFICATION = response?.SHOW_BRM_BUSINESS_RECATEGORIZATION_NOTIFICATION ?? false;
        this.BUSINESSES_RM_AGENTS_TABLE_PAGE_SIZE = response?.BUSINESSES_RM_AGENTS_TABLE_PAGE_SIZE ?? 10;
        this.BUSINESSES_AGENTS_TABLE_PAGE_SIZE = response?.BUSINESSES_AGENTS_TABLE_PAGE_SIZE ?? 10;
        this.SHOW_BRM_ONBOARDING_CLUSTER_NAME = response?.SHOW_BRM_ONBOARDING_CLUSTER_NAME || false;
        this.PARTNER_ONBOARDING_MIGRATION = response?.PARTNER_ONBOARDING_MIGRATION || false;
        this.USE_ANALYTICS_TRACKING_SERVICE_IN_LOANS = response?.USE_ANALYTICS_TRACKING_SERVICE_IN_LOANS || false;
        this.CUSTOMER_IO_WRITE_KEY = response?.CUSTOMER_IO_WRITE_KEY || '';
        AppConfig.SHOW_MONIECRM = response?.SHOW_MONIECRM || false;
        AppConfig.SHOW_TICKET_MANAGER = response?.SHOW_TICKET_MANAGER || false;
        this.SHOW_REPAIR_CODE_UPDATE = response?.SHOW_REPAIR_CODE_UPDATE || false;
        this.SHOW_CUSTOM_TRANSACTION_FIELD_CONFIG = (response && response.SHOW_CUSTOM_TRANSACTION_FIELD_CONFIG) || false;
        this.MONIEPOINT_POS = (response && response.MONIEPOINT_POS) || '';
        this.SHOW_PROFILE_EMAIL_UPDATE_BUTTON = response?.SHOW_PROFILE_EMAIL_UPDATE_BUTTON ?? true;
        this.SHOW_PROFILE_PHONE_NUMBER_UPDATE_BUTTON = response?.SHOW_PROFILE_PHONE_NUMBER_UPDATE_BUTTON ?? true;
        this.SHOW_PROFILE_DOB_UPDATE_BUTTON = response?.SHOW_PROFILE_DOB_UPDATE_BUTTON ?? true;
        this.SHOW_PROFILE_IMAGE_UPDATE_BUTTON = response?.SHOW_PROFILE_IMAGE_UPDATE_BUTTON ?? true;
        this.CUSTOMER_IO_CDN_URL = response?.CUSTOMER_IO_CDN_URL || '';
        this.SHOW_MONIEBOOK_ONBOARDING_ON_BO_DETAILS = response?.SHOW_MONIEBOOK_ONBOARDING_ON_BO_DETAILS || false;
        this.MONIEBOOK_SERVICE_URL = response?.MONIEBOOK_SERVICE_URL || '';
        this.MONIEBOOK_DASHBOARD_URL = response?.MONIEBOOK_DASHBOARD_URL ?? '';
        this.SHOW_MONIEBOOK_AUTO_ONBOARD_BANNER = response?.SHOW_MONIEBOOK_AUTO_ONBOARD_BANNER ?? false;
        AppConfig.MONIEBOOK_FEATURE_SHOW_REFERRALS = (response && response.MONIEBOOK_FEATURE_SHOW_REFERRALS) || false;
        this.REMOVE_TC_DOCUMENT_FOR_BRM = response?.REMOVE_TC_DOCUMENT_FOR_BRM || false;
        this.SHOW_PERFORMANCE_TRACKER_COMMISSION_HISTORY = response?.SHOW_PERFORMANCE_TRACKER_COMMISSION_HISTORY || false;
        this.USE_OTP_WHATSAPP_DEVICE_REGISTRATION = response?.USE_OTP_WHATSAPP_DEVICE_REGISTRATION || false;
        this.USE_OTP_WHATSAPP_FORGOT_PASSCODE = response?.USE_OTP_WHATSAPP_FORGOT_PASSCODE || false;
        this.USE_OTP_WHATSAPP_FORGOT_PASSWORD = response?.USE_OTP_WHATSAPP_FORGOT_PASSWORD || false;
        this.USE_OTP_WHATSAPP_PASSCODE_CHANGE = response?.USE_OTP_WHATSAPP_PASSCODE_CHANGE || false;
        this.USE_OTP_WHATSAPP_PASSWORD_CHANGE = response?.USE_OTP_WHATSAPP_PASSWORD_CHANGE || false;
        this.USE_OTP_WHATSAPP_RESET_USER_PIN = response?.USE_OTP_WHATSAPP_RESET_USER_PIN || false;
        this.SEND_SMS_OTP_2FA = response?.SEND_SMS_OTP_2FA || false;
        this.USE_NEW_OTP_DESIGN_DEVICE_REGISTRATION = response?.USE_NEW_OTP_DESIGN_DEVICE_REGISTRATION ?? true;
        this.SHOULD_USE_KYC_LVL2_UPGRADE_FLOW = response?.SHOULD_USE_KYC_LVL2_UPGRADE_FLOW || false;
        this.WHATSPP_OTP_COUNTDOWN_IN_SECONDS = response?.WHATSPP_OTP_COUNTDOWN_IN_SECONDS || 60;
        this.SHOW_TERMINAL_ASSIGNMENT_TO_BACKOFFICE_UPDATE = response?.SHOW_TERMINAL_ASSIGNMENT_TO_BACKOFFICE_UPDATE || false;
        this.SHOW_UPDATE_TERMINAL_STATUS_ACTION = response?.SHOW_UPDATE_TERMINAL_STATUS_ACTION || false;
        this.SHOW_PROFILE_ADDRESS_UPDATE_BUTTON_KYC_LEVEL = response?.SHOW_PROFILE_ADDRESS_UPDATE_BUTTON_KYC_LEVEL ?? 0;
        AppConfig.CARDS_USE_BRM_AUTHORITIES = response?.CARDS_USE_BRM_AUTHORITIES || false;
        AppConfig.USE_PROVISIONAL_OFFER_GENERATION_FLOW = response?.USE_PROVISIONAL_OFFER_GENERATION_FLOW || false;
        this.SHOW_LIENS_ON_ACCOUNTS_PAGE = response?.SHOW_LIENS_ON_ACCOUNTS_PAGE || false;
        this.CARDS_USE_NEW_ASSIGNMENT_API = response?.CARDS_USE_NEW_ASSIGNMENT_API || false;
        this.USE_NEW_TRANSFER_SUMMARY = response?.USE_NEW_TRANSFER_SUMMARY || false;
        this.MONIECRM_URL = response?.MONIECRM_URL || '';
        this.ADDRESS_VERIFICATION_MFE_URL = response?.ADDRESS_VERIFICATION_MFE_URL || '';
        this.TICKET_MANAGER_URL = response?.TICKET_MANAGER_URL || '';
        this.MONIEPOINT_PAYMENT_URL = response?.MONIEPOINT_PAYMENT_URL || '';
        this.SHOW_BRM_TERMINAL_TRANSACTION_SUMMARY = response?.SHOW_BRM_TERMINAL_TRANSACTION_SUMMARY ?? false;
        this.SHOW_BRM_CARD_SALES_PERFORMANCE_UPDATE = response?.SHOW_BRM_CARD_SALES_PERFORMANCE_UPDATE ?? false;
        this.SHOW_WITHHOLDING_TAX = response?.SHOW_WITHHOLDING_TAX || false;
        this.SHOW_CASHOUT_FEE = response?.SHOW_CASHOUT_FEE || false;
        this.HIDE_SIDEMENU_ON_MOBILE_APP = response?.HIDE_SIDEMENU_ON_MOBILE_APP || false;
        AppConfig.SHOW_CM_MENU_FOR_SC = response?.SHOW_CM_MENU_FOR_SC || false;
        AppConfig.SHOW_CLUSTERS_MENU_FOR_SC = response?.SHOW_CLUSTERS_MENU_FOR_SC || false;
        AppConfig.SHOW_CM_MENU_FOR_RM = response?.SHOW_CM_MENU_FOR_RM || false;
        AppConfig.SHOW_SC_MENU_FOR_RM = response?.SHOW_SC_MENU_FOR_RM || false;
        AppConfig.SHOW_BRM_APPROVALS_MENU_FOR_CM = response?.SHOW_BRM_APPROVALS_MENU_FOR_CM || false;
        AppConfig.SHOW_LIMIT_APPROVAL_MENU_FOR_CM = response?.SHOW_LIMIT_APPROVAL_MENU_FOR_CM || false;
        AppConfig.SHOW_PERFORMANCE_TRACKER_MENU_FOR_CM = response?.SHOW_PERFORMANCE_TRACKER_MENU_FOR_CM || false;
        AppConfig.SHOW_ACCOUNTS_MENU_FOR_CM = response?.SHOW_ACCOUNTS_MENU_FOR_CM || false;
        AppConfig.SHOW_MY_COURSES_MENU_FOR_CM = response?.SHOW_MY_COURSES_MENU_FOR_CM || false;
        AppConfig.SHOW_PERFORMANCE_REPORTS_FOR_CM = response?.SHOW_PERFORMANCE_REPORTS_FOR_CM || false;
        this.DISABLE_AUTO_LOGOUT_ON_MOBILE_APP = response?.DISABLE_AUTO_LOGOUT_ON_MOBILE_APP || false;
        this.SHOW_PROVISIONAL_OFFERS_CONTACT_US = response?.SHOW_PROVISIONAL_OFFERS_CONTACT_US || false;
        this.SHOW_PROVISIONAL_OFFERS_LIST = response?.SHOW_PROVISIONAL_OFFERS_LIST || false;
        this.CARDS_DELIVERY_USE_CARD_SERVICE = response?.CARDS_DELIVERY_USE_CARD_SERVICE || false;
        this.SHOW_POS_WEB_HOOK = (response && response.SHOW_POS_WEB_HOOK) || false;
        this.SHOW_BRM_PENDING_LIST = response?.SHOW_BRM_PENDING_LIST || false;
        this.ENABLE_MARKETER_ONBOARDING = response?.ENABLE_MARKETER_ONBOARDING || false;
        this.SHOW_PROVISIONAL_OFFER_LOAN_TENURE = response?.SHOW_PROVISIONAL_OFFER_LOAN_TENURE || false;
        this.SHOW_PROVISIONAL_OFFER_REPAYMENT_FREQUENCY = response?.SHOW_PROVISIONAL_OFFER_REPAYMENT_FREQUENCY || false;
        this.USE_KYC_BVN_NATIONALITY = response?.USE_KYC_BVN_NATIONALITY || false;
        this.USE_BRM_KYC_BVN_NATIONALITY = response?.USE_BRM_KYC_BVN_NATIONALITY || false;
        this.SHOW_PROFILE_NAME_UPDATE_BUTTON = response?.SHOW_PROFILE_NAME_UPDATE_BUTTON ?? false;
        this.SHOW_PROFILE_DOB_NEW_UPDATE_BUTTON = response?.SHOW_PROFILE_DOB_NEW_UPDATE_BUTTON ?? false;
        this.SHOW_PROFILE_DOB_NEW_UPDATE_SECTION = response?.SHOW_PROFILE_DOB_NEW_UPDATE_SECTION ?? false;
        this.ENABLE_PROFILE_UPDATE_BUTTON_KYC_LEVEL = response?.ENABLE_PROFILE_UPDATE_BUTTON_KYC_LEVEL ?? 0;
        this.SHOW_KFS_PROVISIONAL_OFFER = response?.SHOW_KFS_PROVISIONAL_OFFER || false;
        this.SHOW_REPAYMENT_PLAN_PROVISIONAL_OFFER = response?.SHOW_REPAYMENT_PLAN_PROVISIONAL_OFFER || false;
        this.SHOW_POS_INSURED_FLOW_V2 = response.SHOW_POS_INSURED_FLOW_V2 || false;
        this.SHOW_BRM_INSURE_TERMINAL_FLOW = response?.SHOW_BRM_INSURE_TERMINAL_FLOW || false;
        this.SHOW_INSURANCE_INFO = response?.SHOW_INSURANCE_INFO || false;
        this.SHOW_CARD_DISTRIBUTION_EFFICIENCY_NEW_UI = response.SHOW_CARD_DISTRIBUTION_EFFICIENCY_NEW_UI || false;
        this.SHOW_RETRIVE_BUTTON_CARD_DISTRIBUTION_EFFICIENCY_NEW_UI = response.SHOW_RETRIVE_BUTTON_CARD_DISTRIBUTION_EFFICIENCY_NEW_UI || false;
        this.HIDE_BO_KYC_LVL1_BACK_BUTTON = response?.HIDE_BO_KYC_LVL1_BACK_BUTTON || false;
        this.SHOW_INSURANCE_INFO_KFS = response?.SHOW_INSURANCE_INFO_KFS || false;
        AppConfig.SHOW_REMOTE_GROWTH_MODULE = response?.SHOW_REMOTE_GROWTH_MODULE || false;
        AppConfig.SHOW_REMOTE_ADDRESS_VERIFICATION_MODULE = response?.SHOW_REMOTE_ADDRESS_VERIFICATION_MODULE || false;
        this.SHOW_DEVICES_MFE = response.SHOW_DEVICES_MFE || false;
        this.SHOW_NOTIFICATION_PREFERENCE_MFE = response.SHOW_NOTIFICATION_PREFERENCE_MFE || false;
        this.SHOW_CONSENT_MANAGEMENT_MFE = response.SHOW_CONSENT_MANAGEMENT_MFE || false;
        this.SHOW_BUSINESS_TYPE_MFE = response.SHOW_BUSINESS_TYPE_MFE || false;
        this.SHOW_LANGUAGE_MFE = response.SHOW_LANGUAGE_MFE || false;
        this.SHOW_OTHERS_MFE = response.SHOW_OTHERS_MFE || false;
        this.SHOW_TRANSFER_CONFIGURATION_MFE = response.SHOW_TRANSFER_CONFIGURATION_MFE || false;
        this.SETTINGS_MFE_URL = response.SETTINGS_MFE_URL || '';
        this.PROFILE_SETUP_MFE_URL = response.PROFILE_SETUP_MFE_URL || '';
        this.SHOW_PROFILE_SETUP_MFE = response.SHOW_PROFILE_SETUP_MFE || false;
        this.LOANS_DASHBOARD_WIDGET_URL = response.LOANS_DASHBOARD_WIDGET_URL || '';
        this.LOANS_HOST_URL = response.LOANS_HOST_URL || '';
        this.LOANS_MARKUP_URL = response.LOANS_MARKUP_URL || '';
        this.LOANS_WCL_URL = response.LOANS_WCL_URL || '';
        this.LOANS_OVD_URL = response.LOANS_OVD_URL || '';
        this.LOANS_ASSETS_URL = response.LOANS_ASSETS_URL || '';
        this.LOANS_LOCALES_URL = response.LOANS_LOCALES_URL || '';
        this.SHOW_LOANS_DASHBOARD_WIDGET = response.SHOW_LOANS_DASHBOARD_WIDGET || false;
        AppConfig.USE_NEW_LOAN_AGREEMENT_FLOW = response.USE_NEW_LOAN_AGREEMENT_FLOW || false;
        AppConfig.USE_NEW_LOAN_APP = response.USE_NEW_LOAN_APP || false;
        this.USE_FIRST_LOAN_DISBURSAL_ACCOUNT = response.USE_FIRST_LOAN_DISBURSAL_ACCOUNT || false;
        this.TRANSFER_VALIDATION_FAILURE_MODAL_TITLE = response.TRANSFER_VALIDATION_FAILURE_MODAL_TITLE || '';
        this.SHOW_SAYT_V2 = response.SHOW_SAYT_V2 || false;
        this.GROWTH_URL = response?.GROWTH_URL || '';
        this.GROWTH_V2_URL = response?.GROWTH_V2_URL || '';
        this.USE_MONIEPOINT_MFB_LOGO = response?.USE_MONIEPOINT_MFB_LOGO || false;
        this.SHOW_LICENSED_AND_SECURED_INFO = response?.SHOW_LICENSED_AND_SECURED_INFO || false;
        this.SHOW_BRM_ONBOARDING_PROOF_OF_ADDRESS = response.SHOW_BRM_ONBOARDING_PROOF_OF_ADDRESS || false;
        this.ALWAYS_SHOW_CM_INFO = response.ALWAYS_SHOW_CM_INFO || false;
        this.SHOW_TERMINAL_ASSIGNMENT_TO_BACKOFFICE_CLEANUP = response.SHOW_TERMINAL_ASSIGNMENT_TO_BACKOFFICE_CLEANUP ?? false;
        this.SHOW_TERMS_AND_CONDITION_CHECKBOX = response?.SHOW_TERMS_AND_CONDITION_CHECKBOX || false;
        this.SHOW_STAFF_PROFILE_UPDATE_BUTTON = response?.SHOW_STAFF_PROFILE_UPDATE_BUTTON || false;
        this.SHOW_BRM_ONBOARDING_IDENTIFICATION = response.SHOW_BRM_ONBOARDING_IDENTIFICATION || false;
        this.ENABLE_LOGIN_LOCATION_HEADERS = response.ENABLE_LOGIN_LOCATION_HEADERS || false;
        this.ENABLE_MANDATORY_LOGIN_LOCATION_ACCESS = response.ENABLE_MANDATORY_LOGIN_LOCATION_ACCESS || false;
        this.SHOW_LOAN_REQUEST_FLOW_TENURE = response?.SHOW_LOAN_REQUEST_FLOW_TENURE || false;
        this.SHOW_LOAN_REQUEST_FLOW_REPAYMENT_FREQUENCY = response?.SHOW_LOAN_REQUEST_FLOW_REPAYMENT_FREQUENCY || false;
        this.USE_NEW_BO_KYC_LEVEL3_V3_FLOW = response?.USE_NEW_BO_KYC_LEVEL3_V3_FLOW || false;
        this.SHOW_BUSINESS_BULK_INSURANCE_UPDATE = response.SHOW_BUSINESS_BULK_INSURANCE_UPDATE ?? false;
        this.USE_NEW_BO_KYC_LEVEL3_V3_FLOW = response?.USE_NEW_BO_KYC_LEVEL3_V3_FLOW || false;
        this.OKHI_API_KEY = response?.OKHI_API_KEY || '01J9VPGCXJJRDCR4BVBQB50VHK';
        this.OKHI_BRANCH_ID = response?.OKHI_BRANCH_ID || '67080a4de25a4d900b33a17f';
        this.SHOW_FACE_VERIFICATION_IN_KYC_LVL3 = response.SHOW_FACE_VERIFICATION_IN_KYC_LVL3 || false;
        this.USE_NEW_PRIMARY_ACCOUNT_FLAG_ON_DISBURSEMENT_ACCOUNTS_ENDPOINT =
            response?.USE_NEW_PRIMARY_ACCOUNT_FLAG_ON_DISBURSEMENT_ACCOUNTS_ENDPOINT || false;
        this.USE_NEW_RENEWAL_SUBMISSION_ENDPOINT = response?.USE_NEW_RENEWAL_SUBMISSION_ENDPOINT || false;
        this.MONIEPOINT_SAVINGS_V2_URL = response.MONIEPOINT_SAVINGS_V2_URL || 'https://mab-loans-savings.development.moniepoint.com';
        this.S_CODE1 = response.S_CODE1 ?? '';
        this.S_CODE2 = response.S_CODE2 ?? '';
        this.SHOW_DISBURSEMENT_ACCOUNT_CONFIRMATION_MODAL = response?.SHOW_DISBURSEMENT_ACCOUNT_CONFIRMATION_MODAL || false;
        this.SHOW_OVERDRAFT_MANUAL_REPAYMENT = response?.SHOW_OVERDRAFT_MANUAL_REPAYMENT || false;
        this.GET_BRM_APPROVALS_PENDING_CLAIM_REQUESTS_FOR_CM = response.GET_BRM_APPROVALS_PENDING_CLAIM_REQUESTS_FOR_CM || false;
        this.GET_BRM_APPROVALS_PROCESSING_CLAIM_REQUESTS_FOR_CM = response.GET_BRM_APPROVALS_PROCESSING_CLAIM_REQUESTS_FOR_CM || false;
        this.GET_BRM_APPROVALS_TREATED_CLAIM_REQUESTS_FOR_CM = response.GET_BRM_APPROVALS_TREATED_CLAIM_REQUESTS_FOR_CM || false;
        this.SHOW_BRM_APPROVALS_ACTION_COLUMN_FOR_CM = response.SHOW_BRM_APPROVALS_ACTION_COLUMN_FOR_CM || false;
        this.SHOW_BUSINESS_CATEGORY_UPDATE = response.SHOW_BUSINESS_CATEGORY_UPDATE ?? false;
        this.UPDATE_BUSINESS_CATEGORY_URL = response.UPDATE_BUSINESS_CATEGORY_URL ?? '';
        this.USE_ADDITIONAL_BUSINESS_KYC_LEVEL1 = response?.USE_ADDITIONAL_BUSINESS_KYC_LEVEL1 || false;
        this.BRM_USE_ADDITIONAL_BUSINESS_KYC_LEVEL1 = response?.BRM_USE_ADDITIONAL_BUSINESS_KYC_LEVEL1 || false;
        this.USE_MULTIPLE_BUSINESS_TYPES = response?.USE_MULTIPLE_BUSINESS_TYPES || false;
        this.SHOW_BRM_BUSINESS_TYPES = response?.SHOW_BRM_BUSINESS_TYPES || false;
        this.STORE_FRONT_IMAGE_MAX_SIZE = response?.STORE_FRONT_IMAGE_MAX_SIZE || 0;
        this.MAX_ALLOWED_BUSINESS_TYPES = response?.MAX_ALLOWED_BUSINESS_TYPES || 0;
        this.ENFORCE_LOCATION_DURING_PAYMENT = response?.ENFORCE_LOCATION_DURING_PAYMENT || false;
        this.ENABLE_LOCATION_DURING_PAYMENT = response?.ENABLE_LOCATION_DURING_PAYMENT || false;
        this.ACCOUNT_UPGRADE_MFE_URL = response?.ACCOUNT_UPGRADE_MFE_URL ?? '';
        this.SHOW_ACCOUNT_UPGRADE_MFE = response?.SHOW_ACCOUNT_UPGRADE_MFE ?? false;
        AppConfig.SHOW_PARTNER_UPGRADE_MFE = response?.SHOW_PARTNER_UPGRADE_MFE ?? false;
        this.USE_UPDATED_KYC_LIMITS_FLOW = response?.USE_UPDATED_KYC_LIMITS_FLOW ?? true;
        this.USE_NEW_TERMINALS_ENDPOINT = response?.USE_NEW_TERMINALS_ENDPOINT ?? false;
        this.SHOW_POS_TC = response?.SHOW_POS_TC ?? false;
        this.ENABLE_ONBOARDING_LOCATION_HEADERS = response?.ENABLE_ONBOARDING_LOCATION_HEADERS ?? false;
        this.USE_POLICY_DOCUMENTS_API = response?.USE_POLICY_DOCUMENTS_API || false;
        this.USE_FACETEC_LIVELINESS = response?.USE_FACETEC_LIVELINESS || false;
        this.USE_BRM_FACETEC_LIVELINESS = response?.USE_BRM_FACETEC_LIVELINESS || false;
        this.LIVELINESS_SERVICE_URL = response?.LIVELINESS_SERVICE_URL ?? '';
        this.MFE_CDN_IDENTITY_VERIFICATION_URL = response?.MFE_CDN_IDENTITY_VERIFICATION_URL ?? '';
        this.ENABLE_ACCOUNTS_WALLET_TRANSACTIONS_FOR_CM = response?.ENABLE_ACCOUNTS_WALLET_TRANSACTIONS_FOR_CM || false;
        this.ENABLE_ACCOUNTS_HISTORICAL_TRANSACTIONS_FOR_CM = response?.ENABLE_ACCOUNTS_HISTORICAL_TRANSACTIONS_FOR_CM || false;
        this.ENABLE_ACCOUNTS_CASHOUT_FOR_CM = response?.ENABLE_ACCOUNTS_CASHOUT_FOR_CM || false;
        AppConfig.SHOW_TC_COMPLIANCE_DASHBOARD = response?.SHOW_TC_COMPLIANCE_DASHBOARD ?? false;
        this.USE_BRM_CREATE_BO_BUSINESS_PAGE = response?.USE_BRM_CREATE_BO_BUSINESS_PAGE ?? false;
        this.REMOVE_CHECK_AUTH_FOR_CM = response?.REMOVE_CHECK_AUTH_FOR_CM ?? false;
        this.REMOVE_REFRESH_TOKEN_FOR_CM = response?.REMOVE_REFRESH_TOKEN_FOR_CM ?? false;
        this.HIDE_BRM_PRM_SELF_ONBOARDING_ADDRESS_VERIFICATION = response?.HIDE_BRM_PRM_SELF_ONBOARDING_ADDRESS_VERIFICATION ?? false;
        this.USE_NEW_BUSINESS_TYPES_UI = response?.USE_NEW_BUSINESS_TYPES_UI || false;
        AppConfig.SHOW_MARKETER_ONBOARDING_MFE = response?.SHOW_MARKETER_ONBOARDING_MFE ?? false;
        this.SHOW_POS_TERMINAL_CONDITION_DETAIL_FOR_SC = response?.SHOW_POS_TERMINAL_CONDITION_DETAIL_FOR_SC ?? false;
        this.MONIEPOINT_CONSENT_MANAGEMENT_URL = response?.MONIEPOINT_CONSENT_MANAGEMENT_URL ?? '';
        this.SHOW_PENDING_CONSENT_BANNER = response?.SHOW_PENDING_CONSENT_BANNER ?? false;
        this.SHOW_TERMINAL_SWAP_V4_UPDATE = response?.SHOW_TERMINAL_SWAP_V4_UPDATE ?? false;
        this.USE_KYC_LVL_1_PREVENT_HYBRID_MERCHANT = response?.USE_KYC_LVL_1_PREVENT_HYBRID_MERCHANT ?? false;
        this.USE_BRM_KYC_LVL_1_PREVENT_HYBRID_MERCHANT = response?.USE_BRM_KYC_LVL_1_PREVENT_HYBRID_MERCHANT ?? false;
        this.USE_SOFT_ONBOARDING_PREVENT_HYBRID_MERCHANT = response?.USE_SOFT_ONBOARDING_PREVENT_HYBRID_MERCHANT ?? false;
        this.SHOW_SWAP_HISTORY = response?.SHOW_SWAP_HISTORY ?? false;
        this.SHOW_QUOTA_FOR_NEW_TERMINALS_UPDATE = response?.SHOW_QUOTA_FOR_NEW_TERMINALS_UPDATE ?? false;
        this.ENABLE_BRM_PRM_REQUEST_UPDATION = response?.ENABLE_BRM_PRM_REQUEST_UPDATION ?? false;
        this.USE_UPDATED_CLUSTER_ASSIGNMENT_URL = response?.USE_UPDATED_CLUSTER_ASSIGNMENT_URL ?? false;
        this.ALLOW_SEARCH_BRM_CLUSTER_ASSIGNMENT = response?.ALLOW_SEARCH_BRM_CLUSTER_ASSIGNMENT ?? false;
        AppConfig.USE_MFE_SC_TERMINAL_REQUESTS = response?.USE_MFE_SC_TERMINAL_REQUESTS ?? false;
        this.SHOW_INVENTORY_STATUS_FILTER = response?.SHOW_INVENTORY_STATUS_FILTER ?? false;
        this.MARKETER_ONBOARDING_MFE_URL = response?.MARKETER_ONBOARDING_MFE_URL ?? false;
    }
}
